function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty,
    __getOwnPropSymbols = Object.getOwnPropertySymbols,
    __hasOwnProp = Object.prototype.hasOwnProperty,
    __propIsEnum = Object.prototype.propertyIsEnumerable,
    __defNormalProp = function __defNormalProp(e, u, t) {
  return u in e ? __defProp(e, u, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[u] = t;
},
    __spreadValues = function __spreadValues(e, u) {
  for (var t in u || (u = {})) {
    __hasOwnProp.call(u, t) && __defNormalProp(e, t, u[t]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(u)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        __propIsEnum.call(u, t) && __defNormalProp(e, t, u[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    __require = "undefined" != typeof require ? require : function (e) {
  throw new Error('Dynamic require of "' + e + '" is not supported');
},
    __objRest = function __objRest(e, u) {
  var t = {};

  for (var n in e) {
    __hasOwnProp.call(e, n) && u.indexOf(n) < 0 && (t[n] = e[n]);
  }

  if (null != e && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var n = _step2.value;
        u.indexOf(n) < 0 && __propIsEnum.call(e, n) && (t[n] = e[n]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return t;
};

!function (e) {
  "function" == typeof define && define.amd ? define(e) : e();
}(function () {
  "use strict";

  var e,
      u,
      t,
      n,
      r,
      a,
      d = {},
      i = [],
      o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;

  function c(e, u) {
    for (var t in u) {
      e[t] = u[t];
    }

    return e;
  }

  function l(e) {
    var u = e.parentNode;
    u && u.removeChild(e);
  }

  function s(u, t, n) {
    var r,
        a,
        d,
        i = {};

    for (d in t) {
      "key" == d ? r = t[d] : "ref" == d ? a = t[d] : i[d] = t[d];
    }

    if (arguments.length > 2 && (i.children = arguments.length > 3 ? e.call(arguments, 2) : n), "function" == typeof u && null != u.defaultProps) for (d in u.defaultProps) {
      void 0 === i[d] && (i[d] = u.defaultProps[d]);
    }
    return f(u, i, r, a, null);
  }

  function f(e, n, r, a, d) {
    var i = {
      type: e,
      props: n,
      key: r,
      ref: a,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __d: void 0,
      __c: null,
      __h: null,
      constructor: void 0,
      __v: null == d ? ++t : d
    };
    return null != u.vnode && u.vnode(i), i;
  }

  function p(e) {
    return e.children;
  }

  function h(e, u) {
    this.props = e, this.context = u;
  }

  function v(e, u) {
    if (null == u) return e.__ ? v(e.__, e.__.__k.indexOf(e) + 1) : null;

    for (var t; u < e.__k.length; u++) {
      if (null != (t = e.__k[u]) && null != t.__e) return t.__e;
    }

    return "function" == typeof e.type ? v(e) : null;
  }

  function g(e) {
    var u, t;

    if (null != (e = e.__) && null != e.__c) {
      for (e.__e = e.__c.base = null, u = 0; u < e.__k.length; u++) {
        if (null != (t = e.__k[u]) && null != t.__e) {
          e.__e = e.__c.base = t.__e;
          break;
        }
      }

      return g(e);
    }
  }

  function _(e) {
    (!e.__d && (e.__d = !0) && n.push(e) && !b.__r++ || a !== u.debounceRendering) && ((a = u.debounceRendering) || r)(b);
  }

  function b() {
    for (var e; b.__r = n.length;) {
      e = n.sort(function (e, u) {
        return e.__v.__b - u.__v.__b;
      }), n = [], e.some(function (e) {
        var u, t, n, r, a, d;
        e.__d && (a = (r = (u = e).__v).__e, (d = u.__P) && (t = [], (n = c({}, r)).__v = r.__v + 1, P(d, r, n, u.__n, void 0 !== d.ownerSVGElement, null != r.__h ? [a] : null, t, null == a ? v(r) : a, r.__h), E(t, r), r.__e != a && g(r)));
      });
    }
  }

  function m(e, u, t, n, r, a, o, c, l, s) {
    var h,
        g,
        _,
        b,
        m,
        x,
        k,
        U = n && n.__k || i,
        S = U.length;

    for (t.__k = [], h = 0; h < u.length; h++) {
      if (null != (b = t.__k[h] = null == (b = u[h]) || "boolean" == typeof b ? null : "string" == typeof b || "number" == typeof b || "bigint" == typeof b ? f(null, b, null, null, b) : Array.isArray(b) ? f(p, {
        children: b
      }, null, null, null) : b.__b > 0 ? f(b.type, b.props, b.key, null, b.__v) : b)) {
        if (b.__ = t, b.__b = t.__b + 1, null === (_ = U[h]) || _ && b.key == _.key && b.type === _.type) U[h] = void 0;else for (g = 0; g < S; g++) {
          if ((_ = U[g]) && b.key == _.key && b.type === _.type) {
            U[g] = void 0;
            break;
          }

          _ = null;
        }
        P(e, b, _ = _ || d, r, a, o, c, l, s), m = b.__e, (g = b.ref) && _.ref != g && (k || (k = []), _.ref && k.push(_.ref, null, b), k.push(g, b.__c || m, b)), null != m ? (null == x && (x = m), "function" == typeof b.type && null != b.__k && b.__k === _.__k ? b.__d = l = y(b, l, e) : l = w(e, b, _, U, m, l), s || "option" !== t.type ? "function" == typeof t.type && (t.__d = l) : e.value = "") : l && _.__e == l && l.parentNode != e && (l = v(_));
      }
    }

    for (t.__e = x, h = S; h--;) {
      null != U[h] && ("function" == typeof t.type && null != U[h].__e && U[h].__e == t.__d && (t.__d = v(n, h + 1)), A(U[h], U[h]));
    }

    if (k) for (h = 0; h < k.length; h++) {
      O(k[h], k[++h], k[++h]);
    }
  }

  function y(e, u, t) {
    var n, r;

    for (n = 0; n < e.__k.length; n++) {
      (r = e.__k[n]) && (r.__ = e, u = "function" == typeof r.type ? y(r, u, t) : w(t, r, r, e.__k, r.__e, u));
    }

    return u;
  }

  function x(e, u) {
    return u = u || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some(function (e) {
      x(e, u);
    }) : u.push(e)), u;
  }

  function w(e, u, t, n, r, a) {
    var d, i, o;
    if (void 0 !== u.__d) d = u.__d, u.__d = void 0;else if (null == t || r != a || null == r.parentNode) e: if (null == a || a.parentNode !== e) e.appendChild(r), d = null;else {
      for (i = a, o = 0; (i = i.nextSibling) && o < n.length; o += 2) {
        if (i == r) break e;
      }

      e.insertBefore(r, a), d = a;
    }
    return void 0 !== d ? d : r.nextSibling;
  }

  function k(e, u, t) {
    "-" === u[0] ? e.setProperty(u, t) : e[u] = null == t ? "" : "number" != typeof t || o.test(u) ? t : t + "px";
  }

  function U(e, u, t, n, r) {
    var a;

    e: if ("style" === u) {
      if ("string" == typeof t) e.style.cssText = t;else {
        if ("string" == typeof n && (e.style.cssText = n = ""), n) for (u in n) {
          t && u in t || k(e.style, u, "");
        }
        if (t) for (u in t) {
          n && t[u] === n[u] || k(e.style, u, t[u]);
        }
      }
    } else if ("o" === u[0] && "n" === u[1]) a = u !== (u = u.replace(/Capture$/, "")), u = u.toLowerCase() in e ? u.toLowerCase().slice(2) : u.slice(2), e.l || (e.l = {}), e.l[u + a] = t, t ? n || e.addEventListener(u, a ? C : S, a) : e.removeEventListener(u, a ? C : S, a);else if ("dangerouslySetInnerHTML" !== u) {
      if (r) u = u.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== u && "list" !== u && "form" !== u && "tabIndex" !== u && "download" !== u && u in e) try {
        e[u] = null == t ? "" : t;
        break e;
      } catch (d) {}
      "function" == typeof t || (null != t && (!1 !== t || "a" === u[0] && "r" === u[1]) ? e.setAttribute(u, t) : e.removeAttribute(u));
    }
  }

  function S(e) {
    this.l[e.type + !1](u.event ? u.event(e) : e);
  }

  function C(e) {
    this.l[e.type + !0](u.event ? u.event(e) : e);
  }

  function P(t, n, r, a, i, o, s, f, g) {
    var _,
        b,
        y,
        x,
        w,
        k,
        S,
        C,
        P,
        E,
        O,
        A = n.type;

    if (void 0 !== n.constructor) return null;
    null != r.__h && (g = r.__h, f = n.__e = r.__e, n.__h = null, o = [f]), (_ = u.__b) && _(n);

    try {
      e: if ("function" == typeof A) {
        if (C = n.props, P = (_ = A.contextType) && a[_.__c], E = _ ? P ? P.props.value : _.__ : a, r.__c ? S = (b = n.__c = r.__c).__ = b.__E : ("prototype" in A && A.prototype.render ? n.__c = b = new A(C, E) : (n.__c = b = new h(C, E), b.constructor = A, b.render = j), P && P.sub(b), b.props = C, b.state || (b.state = {}), b.context = E, b.__n = a, y = b.__d = !0, b.__h = []), null == b.__s && (b.__s = b.state), null != A.getDerivedStateFromProps && (b.__s == b.state && (b.__s = c({}, b.__s)), c(b.__s, A.getDerivedStateFromProps(C, b.__s))), x = b.props, w = b.state, y) null == A.getDerivedStateFromProps && null != b.componentWillMount && b.componentWillMount(), null != b.componentDidMount && b.__h.push(b.componentDidMount);else {
          if (null == A.getDerivedStateFromProps && C !== x && null != b.componentWillReceiveProps && b.componentWillReceiveProps(C, E), !b.__e && null != b.shouldComponentUpdate && !1 === b.shouldComponentUpdate(C, b.__s, E) || n.__v === r.__v) {
            b.props = C, b.state = b.__s, n.__v !== r.__v && (b.__d = !1), b.__v = n, n.__e = r.__e, n.__k = r.__k, n.__k.forEach(function (e) {
              e && (e.__ = n);
            }), b.__h.length && s.push(b);
            break e;
          }

          null != b.componentWillUpdate && b.componentWillUpdate(C, b.__s, E), null != b.componentDidUpdate && b.__h.push(function () {
            b.componentDidUpdate(x, w, k);
          });
        }
        b.context = E, b.props = C, b.state = b.__s, (_ = u.__r) && _(n), b.__d = !1, b.__v = n, b.__P = t, _ = b.render(b.props, b.state, b.context), b.state = b.__s, null != b.getChildContext && (a = c(c({}, a), b.getChildContext())), y || null == b.getSnapshotBeforeUpdate || (k = b.getSnapshotBeforeUpdate(x, w)), O = null != _ && _.type === p && null == _.key ? _.props.children : _, m(t, Array.isArray(O) ? O : [O], n, r, a, i, o, s, f, g), b.base = n.__e, n.__h = null, b.__h.length && s.push(b), S && (b.__E = b.__ = null), b.__e = !1;
      } else null == o && n.__v === r.__v ? (n.__k = r.__k, n.__e = r.__e) : n.__e = function (u, t, n, r, a, i, o, c) {
        var s,
            f,
            p,
            h = n.props,
            g = t.props,
            _ = t.type,
            b = 0;
        if ("svg" === _ && (a = !0), null != i) for (; b < i.length; b++) {
          if ((s = i[b]) && (s === u || (_ ? s.localName == _ : 3 == s.nodeType))) {
            u = s, i[b] = null;
            break;
          }
        }

        if (null == u) {
          if (null === _) return document.createTextNode(g);
          u = a ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, g.is && g), i = null, c = !1;
        }

        if (null === _) h === g || c && u.data === g || (u.data = g);else {
          if (i = i && e.call(u.childNodes), f = (h = n.props || d).dangerouslySetInnerHTML, p = g.dangerouslySetInnerHTML, !c) {
            if (null != i) for (h = {}, b = 0; b < u.attributes.length; b++) {
              h[u.attributes[b].name] = u.attributes[b].value;
            }
            (p || f) && (p && (f && p.__html == f.__html || p.__html === u.innerHTML) || (u.innerHTML = p && p.__html || ""));
          }

          if (function (e, u, t, n, r) {
            var a;

            for (a in t) {
              "children" === a || "key" === a || a in u || U(e, a, null, t[a], n);
            }

            for (a in u) {
              r && "function" != typeof u[a] || "children" === a || "key" === a || "value" === a || "checked" === a || t[a] === u[a] || U(e, a, u[a], t[a], n);
            }
          }(u, g, h, a, c), p) t.__k = [];else if (b = t.props.children, m(u, Array.isArray(b) ? b : [b], t, n, r, a && "foreignObject" !== _, i, o, i ? i[0] : n.__k && v(n, 0), c), null != i) for (b = i.length; b--;) {
            null != i[b] && l(i[b]);
          }
          c || ("value" in g && void 0 !== (b = g.value) && (b !== u.value || "progress" === _ && !b) && U(u, "value", b, h.value, !1), "checked" in g && void 0 !== (b = g.checked) && b !== u.checked && U(u, "checked", b, h.checked, !1));
        }
        return u;
      }(r.__e, n, r, a, i, o, s, g);

      (_ = u.diffed) && _(n);
    } catch (T) {
      n.__v = null, (g || null != o) && (n.__e = f, n.__h = !!g, o[o.indexOf(f)] = null), u.__e(T, n, r);
    }
  }

  function E(e, t) {
    u.__c && u.__c(t, e), e.some(function (t) {
      try {
        e = t.__h, t.__h = [], e.some(function (e) {
          e.call(t);
        });
      } catch (n) {
        u.__e(n, t.__v);
      }
    });
  }

  function O(e, t, n) {
    try {
      "function" == typeof e ? e(t) : e.current = t;
    } catch (r) {
      u.__e(r, n);
    }
  }

  function A(e, t, n) {
    var r, a;

    if (u.unmount && u.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || O(r, null, t)), null != (r = e.__c)) {
      if (r.componentWillUnmount) try {
        r.componentWillUnmount();
      } catch (d) {
        u.__e(d, t);
      }
      r.base = r.__P = null;
    }

    if (r = e.__k) for (a = 0; a < r.length; a++) {
      r[a] && A(r[a], t, "function" != typeof e.type);
    }
    n || null == e.__e || l(e.__e), e.__e = e.__d = void 0;
  }

  function j(e, u, t) {
    return this.constructor(e, t);
  }

  function T(t, n, r) {
    var a, i, o;
    u.__ && u.__(t, n), i = (a = "function" == typeof r) ? null : r && r.__k || n.__k, o = [], P(n, t = (!a && r || n).__k = s(p, null, [t]), i || d, d, void 0 !== n.ownerSVGElement, !a && r ? [r] : i ? null : n.firstChild ? e.call(n.childNodes) : null, o, !a && r ? r : i ? i.__e : n.firstChild, a), E(o, t);
  }

  function D(e, u) {
    T(e, u, D);
  }

  function F(u, t, n) {
    var r,
        a,
        d,
        i = c({}, u.props);

    for (d in t) {
      "key" == d ? r = t[d] : "ref" == d ? a = t[d] : i[d] = t[d];
    }

    return arguments.length > 2 && (i.children = arguments.length > 3 ? e.call(arguments, 2) : n), f(u.type, i, r || u.key, a || u.ref, null);
  }

  function L() {
    return (L = Object.assign || function (e) {
      for (var u = 1; u < arguments.length; u++) {
        var t = arguments[u];

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function N(e) {
    return this.getChildContext = function () {
      return e.context;
    }, F(e.children, function (e, u) {
      if (null == e) return {};
      var t,
          n,
          r = {},
          a = Object.keys(e);

      for (n = 0; n < a.length; n++) {
        u.indexOf(t = a[n]) >= 0 || (r[t] = e[t]);
      }

      return r;
    }(e, ["context", "children"]));
  }

  function z() {
    var e = new CustomEvent("_preact", {
      detail: {},
      bubbles: !0,
      cancelable: !0
    });
    this.dispatchEvent(e), this._vdom = s(N, L({}, this._props, {
      context: e.detail.context
    }), function e(u, t) {
      if (3 === u.nodeType) return u.data;
      if (1 !== u.nodeType) return null;
      var n = [],
          r = {},
          a = 0,
          d = u.attributes,
          i = u.childNodes;

      for (a = d.length; a--;) {
        "slot" !== d[a].name && (r[d[a].name] = d[a].value, r[M(d[a].name)] = d[a].value);
      }

      for (a = i.length; a--;) {
        var o = e(i[a], null),
            c = i[a].slot;
        c ? r[c] = s(B, {
          name: c
        }, o) : n[a] = o;
      }

      var l = t ? s(B, null, n) : n;
      return s(t || u.nodeName.toLowerCase(), r, l);
    }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? D : T)(this._vdom, this._root);
  }

  function M(e) {
    return e.replace(/-(\w)/g, function (e, u) {
      return u ? u.toUpperCase() : "";
    });
  }

  function I(e, u, t) {
    if (this._vdom) {
      var n = {};
      n[e] = t = null == t ? void 0 : t, n[M(e)] = t, this._vdom = F(this._vdom, n), T(this._vdom, this._root);
    }
  }

  function R() {
    T(this._vdom = null, this._root);
  }

  function B(e, u) {
    var t = this;
    return s("slot", L({}, e, {
      ref: function ref(e) {
        e ? (t.ref = e, t._listener || (t._listener = function (e) {
          e.stopPropagation(), e.detail.context = u;
        }, e.addEventListener("_preact", t._listener))) : t.ref.removeEventListener("_preact", t._listener);
      }
    }));
  }

  e = i.slice, u = {
    __e: function __e(e, u) {
      for (var t, n, r; u = u.__;) {
        if ((t = u.__c) && !t.__) try {
          if ((n = t.constructor) && null != n.getDerivedStateFromError && (t.setState(n.getDerivedStateFromError(e)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(e), r = t.__d), r) return t.__E = t;
        } catch (a) {
          e = a;
        }
      }

      throw e;
    }
  }, t = 0, h.prototype.setState = function (e, u) {
    var t;
    t = null != this.__s && this.__s !== this.state ? this.__s : this.__s = c({}, this.state), "function" == typeof e && (e = e(c({}, t), this.props)), e && c(t, e), null != e && this.__v && (u && this.__h.push(u), _(this));
  }, h.prototype.forceUpdate = function (e) {
    this.__v && (this.__e = !0, e && this.__h.push(e), _(this));
  }, h.prototype.render = p, n = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, b.__r = 0;
  var H,
      $,
      W,
      G = 0,
      q = [],
      V = u.__b,
      Q = u.__r,
      Z = u.diffed,
      J = u.__c,
      K = u.unmount;

  function Y(e, t) {
    u.__h && u.__h($, e, G || t), G = 0;
    var n = $.__H || ($.__H = {
      __: [],
      __h: []
    });
    return e >= n.__.length && n.__.push({}), n.__[e];
  }

  function X(e, u) {
    var t = Y(H++, 7);
    return re(t.__H, u) && (t.__ = e(), t.__H = u, t.__h = e), t.__;
  }

  function ee() {
    q.forEach(function (e) {
      if (e.__P) try {
        e.__H.__h.forEach(te), e.__H.__h.forEach(ne), e.__H.__h = [];
      } catch (t) {
        e.__H.__h = [], u.__e(t, e.__v);
      }
    }), q = [];
  }

  u.__b = function (e) {
    $ = null, V && V(e);
  }, u.__r = function (e) {
    Q && Q(e), H = 0;
    var u = ($ = e.__c).__H;
    u && (u.__h.forEach(te), u.__h.forEach(ne), u.__h = []);
  }, u.diffed = function (e) {
    Z && Z(e);
    var t = e.__c;
    t && t.__H && t.__H.__h.length && (1 !== q.push(t) && W === u.requestAnimationFrame || ((W = u.requestAnimationFrame) || function (e) {
      var u,
          t = function t() {
        clearTimeout(n), ue && cancelAnimationFrame(u), setTimeout(e);
      },
          n = setTimeout(t, 100);

      ue && (u = requestAnimationFrame(t));
    })(ee)), $ = void 0;
  }, u.__c = function (e, t) {
    t.some(function (e) {
      try {
        e.__h.forEach(te), e.__h = e.__h.filter(function (e) {
          return !e.__ || ne(e);
        });
      } catch (n) {
        t.some(function (e) {
          e.__h && (e.__h = []);
        }), t = [], u.__e(n, e.__v);
      }
    }), J && J(e, t);
  }, u.unmount = function (e) {
    K && K(e);
    var t = e.__c;
    if (t && t.__H) try {
      t.__H.__.forEach(te);
    } catch (n) {
      u.__e(n, t.__v);
    }
  };
  var ue = "function" == typeof requestAnimationFrame;

  function te(e) {
    var u = $;
    "function" == typeof e.__c && e.__c(), $ = u;
  }

  function ne(e) {
    var u = $;
    e.__c = e.__(), $ = u;
  }

  function re(e, u) {
    return !e || e.length !== u.length || u.some(function (u, t) {
      return u !== e[t];
    });
  }

  function ae(e, u) {
    for (var t in e) {
      if ("__source" !== t && !(t in u)) return !0;
    }

    for (var n in u) {
      if ("__source" !== n && e[n] !== u[n]) return !0;
    }

    return !1;
  }

  function de(e) {
    this.props = e;
  }

  (de.prototype = new h()).isPureReactComponent = !0, de.prototype.shouldComponentUpdate = function (e, u) {
    return ae(this.props, e) || ae(this.state, u);
  };
  var ie = u.__b;

  u.__b = function (e) {
    e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), ie && ie(e);
  };

  var oe = u.__e;

  u.__e = function (e, u, t) {
    if (e.then) for (var n, r = u; r = r.__;) {
      if ((n = r.__c) && n.__c) return null == u.__e && (u.__e = t.__e, u.__k = t.__k), n.__c(e, u);
    }
    oe(e, u, t);
  };

  var ce = u.unmount;

  function le() {
    this.__u = 0, this.t = null, this.__b = null;
  }

  function se(e) {
    var u = e.__.__c;
    return u && u.__e && u.__e(e);
  }

  function fe() {
    this.u = null, this.o = null;
  }

  u.unmount = function (e) {
    var u = e.__c;
    u && u.__R && u.__R(), u && !0 === e.__h && (e.type = null), ce && ce(e);
  }, (le.prototype = new h()).__c = function (e, u) {
    var t = u.__c,
        n = this;
    null == n.t && (n.t = []), n.t.push(t);

    var r = se(n.__v),
        a = !1,
        d = function d() {
      a || (a = !0, t.__R = null, r ? r(i) : i());
    };

    t.__R = d;

    var i = function i() {
      if (! --n.__u) {
        if (n.state.__e) {
          var e = n.state.__e;

          n.__v.__k[0] = function e(u, t, n) {
            return u && (u.__v = null, u.__k = u.__k && u.__k.map(function (u) {
              return e(u, t, n);
            }), u.__c && u.__c.__P === t && (u.__e && n.insertBefore(u.__e, u.__d), u.__c.__e = !0, u.__c.__P = n)), u;
          }(e, e.__c.__P, e.__c.__O);
        }

        var u;

        for (n.setState({
          __e: n.__b = null
        }); u = n.t.pop();) {
          u.forceUpdate();
        }
      }
    },
        o = !0 === u.__h;

    n.__u++ || o || n.setState({
      __e: n.__b = n.__v.__k[0]
    }), e.then(d, d);
  }, le.prototype.componentWillUnmount = function () {
    this.t = [];
  }, le.prototype.render = function (e, u) {
    if (this.__b) {
      if (this.__v.__k) {
        var t = document.createElement("div"),
            n = this.__v.__k[0].__c;

        this.__v.__k[0] = function e(u, t, n) {
          return u && (u.__c && u.__c.__H && (u.__c.__H.__.forEach(function (e) {
            "function" == typeof e.__c && e.__c();
          }), u.__c.__H = null), null != (u = function (e, u) {
            for (var t in u) {
              e[t] = u[t];
            }

            return e;
          }({}, u)).__c && (u.__c.__P === n && (u.__c.__P = t), u.__c = null), u.__k = u.__k && u.__k.map(function (u) {
            return e(u, t, n);
          })), u;
        }(this.__b, t, n.__O = n.__P);
      }

      this.__b = null;
    }

    var r = u.__e && s(p, null, e.fallback);
    return r && (r.__h = null), [s(p, null, u.__e ? null : e.children), r];
  };

  var pe = function pe(e, u, t) {
    if (++t[1] === t[0] && e.o.delete(u), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.o.size)) for (t = e.u; t;) {
      for (; t.length > 3;) {
        t.pop()();
      }

      if (t[1] < t[0]) break;
      e.u = t = t[2];
    }
  };

  (fe.prototype = new h()).__e = function (e) {
    var u = this,
        t = se(u.__v),
        n = u.o.get(e);
    return n[0]++, function (r) {
      var a = function a() {
        u.props.revealOrder ? (n.push(r), pe(u, e, n)) : r();
      };

      t ? t(a) : a();
    };
  }, fe.prototype.render = function (e) {
    this.u = null, this.o = new Map();
    var u = x(e.children);
    e.revealOrder && "b" === e.revealOrder[0] && u.reverse();

    for (var t = u.length; t--;) {
      this.o.set(u[t], this.u = [1, 0, this.u]);
    }

    return e.children;
  }, fe.prototype.componentDidUpdate = fe.prototype.componentDidMount = function () {
    var e = this;
    this.o.forEach(function (u, t) {
      pe(e, t, u);
    });
  };

  var he = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
      ve = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
      ge = function ge(e) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(e);
  };

  h.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (e) {
    Object.defineProperty(h.prototype, e, {
      configurable: !0,
      get: function get() {
        return this["UNSAFE_" + e];
      },
      set: function set(u) {
        Object.defineProperty(this, e, {
          configurable: !0,
          writable: !0,
          value: u
        });
      }
    });
  });
  var _e = u.event;

  function be() {}

  function me() {
    return this.cancelBubble;
  }

  function ye() {
    return this.defaultPrevented;
  }

  u.event = function (e) {
    return _e && (e = _e(e)), e.persist = be, e.isPropagationStopped = me, e.isDefaultPrevented = ye, e.nativeEvent = e;
  };

  var xe = {
    configurable: !0,
    get: function get() {
      return this.class;
    }
  },
      we = u.vnode;

  u.vnode = function (e) {
    var u = e.type,
        t = e.props,
        n = t;

    if ("string" == typeof u) {
      for (var r in n = {}, t) {
        var a = t[r];
        "value" === r && "defaultValue" in t && null == a || ("defaultValue" === r && "value" in t && null == t.value ? r = "value" : "download" === r && !0 === a ? a = "" : /ondoubleclick/i.test(r) ? r = "ondblclick" : /^onchange(textarea|input)/i.test(r + u) && !ge(t.type) ? r = "oninput" : /^on(Ani|Tra|Tou|BeforeInp)/.test(r) ? r = r.toLowerCase() : ve.test(r) ? r = r.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === a && (a = void 0), n[r] = a);
      }

      "select" == u && n.multiple && Array.isArray(n.value) && (n.value = x(t.children).forEach(function (e) {
        e.props.selected = -1 != n.value.indexOf(e.props.value);
      })), "select" == u && null != n.defaultValue && (n.value = x(t.children).forEach(function (e) {
        e.props.selected = n.multiple ? -1 != n.defaultValue.indexOf(e.props.value) : n.defaultValue == e.props.value;
      })), e.props = n;
    }

    u && t.class != t.className && (xe.enumerable = "className" in t, null != t.className && (n.class = t.className), Object.defineProperty(n, "className", xe)), e.$$typeof = he, we && we(e);
  };

  var ke = u.__r;

  u.__r = function (e) {
    ke && ke(e);
  };

  var Ue = function Ue(e) {
    return s("a", {
      href: e.href,
      className: e.className,
      rel: "noopener noreferrer",
      target: "_blank",
      "aria-label": "View on Twitter",
      role: "link"
    }, e.children);
  },
      Se = function Se(e) {
    var u = e.imageUrl,
        t = e.tweetUrl,
        n = e.className;
    return s(p, null, s(Ue, {
      className: "user-icon ".concat(n),
      href: t
    }, s("img", {
      class: "user-icon__image",
      src: u,
      alt: "twitter user profile image"
    }), s("div", {
      className: "user-icon__boarder"
    })), s("style", {
      jsx: !0
    }, "\n        .user-icon {\n          position: relative;\n          height: 46px;\n          width: 46px;\n        }\n        .user-icon__image {\n          width: 100%;\n          height: 100%;\n          border-radius: 9999px;\n        }\n        .user-icon__boarder {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n\n          border-radius: 9999px;\n          border: 1px solid rgba(0, 0, 0, 0.04);\n        }\n      "));
  },
      Ce = function Ce(e) {
    var u = e,
        t = u.children,
        n = __objRest(u, ["children"]);

    return s("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "rgb(29, 161, 242)"
    }, n), s("path", {
      d: "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"
    }));
  },
      Pe = function Pe(e) {
    var u = e.tweetUrl,
        t = e.user,
        n = t.name,
        r = t.profile_image_url_https,
        a = t.screen_name,
        d = t.verified;
    return s(p, null, s("div", {
      className: "user-info"
    }, s(Se, {
      className: "user-info__icon",
      imageUrl: r,
      tweetUrl: u
    }), s(Ue, {
      className: "user-info__name",
      href: u
    }, s("div", {
      className: "name__display-name"
    }, n), s("div", {
      className: "name__screen-name"
    }, "@".concat(a))), s(Ue, {
      className: "user-info__twitter-icon",
      href: u
    }, s(Ce, null))), s("style", {
      jsx: !0
    }, '\n        .user-info {\n          display: flex;\n          padding-bottom: 12px;\n        }\n\n        .user-info__icon {\n        }\n\n        .user-info__name {\n          margin: 0 4px;\n          display: flex;\n          justify-content: center;\n          flex-direction: column;\n        }\n\n        .name__display-name {\n          font-weight: 700;\n          font-size: 15px;\n          color: rgb(15, 20, 25);\n          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,\n            Helvetica, Arial, sans-serif;\n          line-height: 20px;\n        }\n\n        .tweet a:hover .name__display-name {\n          text-decoration: underline;\n        }\n\n        .name__screen-name {\n          line-height: 20px;\n          color: rgb(83, 100, 113);\n          font-weight: 400;\n          font-size: 15px;\n          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,\n            Helvetica, Arial, sans-serif;\n        }\n\n        .user-info__twitter-icon {\n          margin-left: auto;\n        }\n      '));
  };

  var Ee = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
      Oe = function Oe(e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  },
      Ae = Oe,
      je = function je(e) {
    if (!Ae(e)) throw TypeError(e + " is not an object!");
    return e;
  },
      Te = function Te(e) {
    if (null == e) throw TypeError("Can't call method on  " + e);
    return e;
  },
      De = Te,
      Fe = function Fe(e) {
    return Object(De(e));
  },
      Le = Math.ceil,
      Ne = Math.floor,
      ze = function ze(e) {
    return isNaN(e = +e) ? 0 : (e > 0 ? Ne : Le)(e);
  },
      Me = ze,
      Ie = Math.min,
      Re = function Re(e) {
    return e > 0 ? Ie(Me(e), 9007199254740991) : 0;
  },
      Be = ze,
      He = Te,
      $e = function $e(e) {
    return function (u, t) {
      var n,
          r,
          a = String(He(u)),
          d = Be(t),
          i = a.length;
      return d < 0 || d >= i ? e ? "" : void 0 : (n = a.charCodeAt(d)) < 55296 || n > 56319 || d + 1 === i || (r = a.charCodeAt(d + 1)) < 56320 || r > 57343 ? e ? a.charAt(d) : n : e ? a.slice(d, d + 2) : r - 56320 + (n - 55296 << 10) + 65536;
    };
  },
      We = $e(!0),
      Ge = function Ge(e, u, t) {
    return u + (t ? We(e, u).length : 1);
  },
      qe = {}.toString,
      Ve = function Ve(e) {
    return qe.call(e).slice(8, -1);
  },
      Qe = {
    exports: {}
  },
      Ze = {
    exports: {}
  },
      Je = {
    exports: {}
  },
      Ke = Je.exports = {
    version: "2.6.12"
  };

  "number" == typeof __e && (__e = Ke);
  var Ye = {
    exports: {}
  },
      Xe = Ye.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = Xe);
  var eu = Je.exports,
      uu = Ye.exports,
      tu = "__core-js_shared__",
      nu = uu[tu] || (uu[tu] = {});
  (Ze.exports = function (e, u) {
    return nu[e] || (nu[e] = void 0 !== u ? u : {});
  })("versions", []).push({
    version: eu.version,
    mode: "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
  });

  var ru = 0,
      au = Math.random(),
      du = function du(e) {
    return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++ru + au).toString(36));
  },
      iu = Ze.exports("wks"),
      ou = du,
      cu = Ye.exports.Symbol,
      lu = "function" == typeof cu;

  (Qe.exports = function (e) {
    return iu[e] || (iu[e] = lu && cu[e] || (lu ? cu : ou)("Symbol." + e));
  }).store = iu;

  var su,
      fu,
      pu = Ve,
      hu = Qe.exports("toStringTag"),
      vu = "Arguments" == pu(function () {
    return arguments;
  }()),
      gu = function gu(e) {
    var u, t, n;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (t = function (e, u) {
      try {
        return e[u];
      } catch (t) {}
    }(u = Object(e), hu)) ? t : vu ? pu(u) : "Object" == (n = pu(u)) && "function" == typeof u.callee ? "Arguments" : n;
  },
      _u = gu,
      bu = RegExp.prototype.exec,
      mu = function mu(e, u) {
    var t = e.exec;

    if ("function" == typeof t) {
      var n = t.call(e, u);
      if ("object" != typeof n) throw new TypeError("RegExp exec method returned something other than an Object or null");
      return n;
    }

    if ("RegExp" !== _u(e)) throw new TypeError("RegExp#exec called on incompatible receiver");
    return bu.call(e, u);
  },
      yu = je,
      xu = function xu() {
    var e = yu(this),
        u = "";
    return e.global && (u += "g"), e.ignoreCase && (u += "i"), e.multiline && (u += "m"), e.unicode && (u += "u"), e.sticky && (u += "y"), u;
  },
      wu = xu,
      ku = RegExp.prototype.exec,
      Uu = String.prototype.replace,
      Su = ku,
      Cu = (su = /a/, fu = /b*/g, ku.call(su, "a"), ku.call(fu, "a"), 0 !== su.lastIndex || 0 !== fu.lastIndex),
      Pu = void 0 !== /()??/.exec("")[1];

  (Cu || Pu) && (Su = function Su(e) {
    var u,
        t,
        n,
        r,
        a = this;
    return Pu && (t = new RegExp("^" + a.source + "$(?!\\s)", wu.call(a))), Cu && (u = a.lastIndex), n = ku.call(a, e), Cu && n && (a.lastIndex = a.global ? n.index + n[0].length : u), Pu && n && n.length > 1 && Uu.call(n[0], t, function () {
      for (r = 1; r < arguments.length - 2; r++) {
        void 0 === arguments[r] && (n[r] = void 0);
      }
    }), n;
  });

  var Eu = Su,
      Ou = {},
      Au = function Au(e) {
    try {
      return !!e();
    } catch (u) {
      return !0;
    }
  },
      ju = !Au(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      Tu = Oe,
      Du = Ye.exports.document,
      Fu = Tu(Du) && Tu(Du.createElement),
      Lu = function Lu(e) {
    return Fu ? Du.createElement(e) : {};
  },
      Nu = !ju && !Au(function () {
    return 7 != Object.defineProperty(Lu("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      zu = Oe,
      Mu = function Mu(e, u) {
    if (!zu(e)) return e;
    var t, n;
    if (u && "function" == typeof (t = e.toString) && !zu(n = t.call(e))) return n;
    if ("function" == typeof (t = e.valueOf) && !zu(n = t.call(e))) return n;
    if (!u && "function" == typeof (t = e.toString) && !zu(n = t.call(e))) return n;
    throw TypeError("Can't convert object to primitive value");
  },
      Iu = je,
      Ru = Nu,
      Bu = Mu,
      Hu = Object.defineProperty;

  Ou.f = ju ? Object.defineProperty : function (e, u, t) {
    if (Iu(e), u = Bu(u, !0), Iu(t), Ru) try {
      return Hu(e, u, t);
    } catch (n) {}
    if ("get" in t || "set" in t) throw TypeError("Accessors not supported!");
    return "value" in t && (e[u] = t.value), e;
  };

  var $u = function $u(e, u) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: u
    };
  },
      Wu = Ou,
      Gu = $u,
      qu = ju ? function (e, u, t) {
    return Wu.f(e, u, Gu(1, t));
  } : function (e, u, t) {
    return e[u] = t, e;
  },
      Vu = {
    exports: {}
  },
      Qu = {}.hasOwnProperty,
      Zu = function Zu(e, u) {
    return Qu.call(e, u);
  },
      Ju = Ze.exports("native-function-to-string", Function.toString),
      Ku = Ye.exports,
      Yu = qu,
      Xu = Zu,
      et = du("src"),
      ut = Ju,
      tt = "toString",
      nt = ("" + ut).split(tt);

  Je.exports.inspectSource = function (e) {
    return ut.call(e);
  }, (Vu.exports = function (e, u, t, n) {
    var r = "function" == typeof t;
    r && (Xu(t, "name") || Yu(t, "name", u)), e[u] !== t && (r && (Xu(t, et) || Yu(t, et, e[u] ? "" + e[u] : nt.join(String(u)))), e === Ku ? e[u] = t : n ? e[u] ? e[u] = t : Yu(e, u, t) : (delete e[u], Yu(e, u, t)));
  })(Function.prototype, tt, function () {
    return "function" == typeof this && this[et] || ut.call(this);
  });

  var rt = function rt(e) {
    if ("function" != typeof e) throw TypeError(e + " is not a function!");
    return e;
  },
      at = rt,
      dt = function dt(e, u, t) {
    if (at(e), void 0 === u) return e;

    switch (t) {
      case 1:
        return function (t) {
          return e.call(u, t);
        };

      case 2:
        return function (t, n) {
          return e.call(u, t, n);
        };

      case 3:
        return function (t, n, r) {
          return e.call(u, t, n, r);
        };
    }

    return function () {
      return e.apply(u, arguments);
    };
  },
      it = Ye.exports,
      ot = Je.exports,
      ct = qu,
      lt = Vu.exports,
      st = dt,
      ft = function ft(e, u, t) {
    var n,
        r,
        a,
        d,
        i = e & ft.F,
        o = e & ft.G,
        c = e & ft.S,
        l = e & ft.P,
        s = e & ft.B,
        f = o ? it : c ? it[u] || (it[u] = {}) : (it[u] || {}).prototype,
        p = o ? ot : ot[u] || (ot[u] = {}),
        h = p.prototype || (p.prototype = {});

    for (n in o && (t = u), t) {
      a = ((r = !i && f && void 0 !== f[n]) ? f : t)[n], d = s && r ? st(a, it) : l && "function" == typeof a ? st(Function.call, a) : a, f && lt(f, n, a, e & ft.U), p[n] != a && ct(p, n, d), l && h[n] != a && (h[n] = a);
    }
  };

  it.core = ot, ft.F = 1, ft.G = 2, ft.S = 4, ft.P = 8, ft.B = 16, ft.W = 32, ft.U = 64, ft.R = 128;
  var pt = ft;
  pt({
    target: "RegExp",
    proto: !0,
    forced: Eu !== /./.exec
  }, {
    exec: Eu
  });

  var ht = Vu.exports,
      vt = qu,
      gt = Au,
      _t = Te,
      bt = Qe.exports,
      mt = Eu,
      yt = bt("species"),
      xt = !gt(function () {
    var e = /./;
    return e.exec = function () {
      var e = [];
      return e.groups = {
        a: "7"
      }, e;
    }, "7" !== "".replace(e, "$<a>");
  }),
      wt = function () {
    var e = /(?:)/,
        u = e.exec;

    e.exec = function () {
      return u.apply(this, arguments);
    };

    var t = "ab".split(e);
    return 2 === t.length && "a" === t[0] && "b" === t[1];
  }(),
      kt = function kt(e, u, t) {
    var n = bt(e),
        r = !gt(function () {
      var u = {};
      return u[n] = function () {
        return 7;
      }, 7 != ""[e](u);
    }),
        a = r ? !gt(function () {
      var u = !1,
          t = /a/;
      return t.exec = function () {
        return u = !0, null;
      }, "split" === e && (t.constructor = {}, t.constructor[yt] = function () {
        return t;
      }), t[n](""), !u;
    }) : void 0;

    if (!r || !a || "replace" === e && !xt || "split" === e && !wt) {
      var d = /./[n],
          i = t(_t, n, ""[e], function (e, u, t, n, a) {
        return u.exec === mt ? r && !a ? {
          done: !0,
          value: d.call(u, t, n)
        } : {
          done: !0,
          value: e.call(t, u, n)
        } : {
          done: !1
        };
      }),
          o = i[0],
          c = i[1];
      ht(String.prototype, e, o), vt(RegExp.prototype, n, 2 == u ? function (e, u) {
        return c.call(e, this, u);
      } : function (e) {
        return c.call(e, this);
      });
    }
  },
      Ut = je,
      St = Fe,
      Ct = Re,
      Pt = ze,
      Et = Ge,
      Ot = mu,
      At = Math.max,
      jt = Math.min,
      Tt = Math.floor,
      Dt = /\$([$&`']|\d\d?|<[^>]*>)/g,
      Ft = /\$([$&`']|\d\d?)/g;

  kt("replace", 2, function (e, u, t, n) {
    return [function (n, r) {
      var a = e(this),
          d = null == n ? void 0 : n[u];
      return void 0 !== d ? d.call(n, a, r) : t.call(String(a), n, r);
    }, function (e, u) {
      var a = n(t, e, this, u);
      if (a.done) return a.value;
      var d = Ut(e),
          i = String(this),
          o = "function" == typeof u;
      o || (u = String(u));
      var c = d.global;

      if (c) {
        var l = d.unicode;
        d.lastIndex = 0;
      }

      for (var s = [];;) {
        var f = Ot(d, i);
        if (null === f) break;
        if (s.push(f), !c) break;
        "" === String(f[0]) && (d.lastIndex = Et(i, Ct(d.lastIndex), l));
      }

      for (var p, h = "", v = 0, g = 0; g < s.length; g++) {
        f = s[g];

        for (var _ = String(f[0]), b = At(jt(Pt(f.index), i.length), 0), m = [], y = 1; y < f.length; y++) {
          m.push(void 0 === (p = f[y]) ? p : String(p));
        }

        var x = f.groups;

        if (o) {
          var w = [_].concat(m, b, i);
          void 0 !== x && w.push(x);
          var k = String(u.apply(void 0, w));
        } else k = r(_, i, b, m, x, u);

        b >= v && (h += i.slice(v, b) + k, v = b + _.length);
      }

      return h + i.slice(v);
    }];

    function r(e, u, n, r, a, d) {
      var i = n + e.length,
          o = r.length,
          c = Ft;
      return void 0 !== a && (a = St(a), c = Dt), t.call(d, c, function (t, d) {
        var c;

        switch (d.charAt(0)) {
          case "$":
            return "$";

          case "&":
            return e;

          case "`":
            return u.slice(0, n);

          case "'":
            return u.slice(i);

          case "<":
            c = a[d.slice(1, -1)];
            break;

          default:
            var l = +d;
            if (0 === l) return t;

            if (l > o) {
              var s = Tt(l / 10);
              return 0 === s ? t : s <= o ? void 0 === r[s - 1] ? d.charAt(1) : r[s - 1] + d.charAt(1) : t;
            }

            c = r[l - 1];
        }

        return void 0 === c ? "" : c;
      });
    }
  });

  var Lt = Ve,
      Nt = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
    return "String" == Lt(e) ? e.split("") : Object(e);
  },
      zt = Nt,
      Mt = Te,
      It = function It(e) {
    return zt(Mt(e));
  },
      Rt = ze,
      Bt = Math.max,
      Ht = Math.min,
      $t = It,
      Wt = Re,
      Gt = function Gt(e, u) {
    return (e = Rt(e)) < 0 ? Bt(e + u, 0) : Ht(e, u);
  },
      qt = function qt(e) {
    return function (u, t, n) {
      var r,
          a = $t(u),
          d = Wt(a.length),
          i = Gt(n, d);

      if (e && t != t) {
        for (; d > i;) {
          if ((r = a[i++]) != r) return !0;
        }
      } else for (; d > i; i++) {
        if ((e || i in a) && a[i] === t) return e || i || 0;
      }

      return !e && -1;
    };
  },
      Vt = Au,
      Qt = function Qt(e, u) {
    return !!e && Vt(function () {
      u ? e.call(null, function () {}, 1) : e.call(null);
    });
  },
      Zt = pt,
      Jt = qt(!1),
      Kt = [].indexOf,
      Yt = !!Kt && 1 / [1].indexOf(1, -0) < 0;

  Zt(Zt.P + Zt.F * (Yt || !Qt(Kt)), "Array", {
    indexOf: function indexOf(e) {
      return Yt ? Kt.apply(this, arguments) || 0 : Jt(this, e, arguments[1]);
    }
  });
  var Xt = /[a-z]{1,6}(?:[._][a-z]{1,2})?/i,
      en = /\!'#%&'\(\)*\+,\\\-\.\/:;<=>\?@\[\]\^_{|}~\$/,
      un = {},
      tn = {};
  tn.f = {}.propertyIsEnumerable;
  var nn = tn,
      rn = $u,
      an = It,
      dn = Mu,
      on = Zu,
      cn = Nu,
      ln = Object.getOwnPropertyDescriptor;
  un.f = ju ? ln : function (e, u) {
    if (e = an(e), u = dn(u, !0), cn) try {
      return ln(e, u);
    } catch (t) {}
    if (on(e, u)) return rn(!nn.f.call(e, u), e[u]);
  };

  var sn = Oe,
      fn = je,
      pn = function pn(e, u) {
    if (fn(e), !sn(u) && null !== u) throw TypeError(u + ": can't set as prototype!");
  },
      hn = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, u, t) {
      try {
        (t = dt(Function.call, un.f(Object.prototype, "__proto__").set, 2))(e, []), u = !(e instanceof Array);
      } catch (n) {
        u = !0;
      }

      return function (e, n) {
        return pn(e, n), u ? e.__proto__ = n : t(e, n), e;
      };
    }({}, !1) : void 0),
    check: pn
  },
      vn = Oe,
      gn = hn.set,
      _n = {},
      bn = Ze.exports("keys"),
      mn = du,
      yn = function yn(e) {
    return bn[e] || (bn[e] = mn(e));
  },
      xn = Zu,
      wn = It,
      kn = qt(!1),
      Un = yn("IE_PROTO"),
      Sn = function Sn(e, u) {
    var t,
        n = wn(e),
        r = 0,
        a = [];

    for (t in n) {
      t != Un && xn(n, t) && a.push(t);
    }

    for (; u.length > r;) {
      xn(n, t = u[r++]) && (~kn(a, t) || a.push(t));
    }

    return a;
  },
      Cn = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
      Pn = Sn,
      En = Cn.concat("length", "prototype");

  _n.f = Object.getOwnPropertyNames || function (e) {
    return Pn(e, En);
  };

  var On,
      An = Oe,
      jn = Ve,
      Tn = Qe.exports("match"),
      Dn = function Dn(e) {
    var u;
    return An(e) && (void 0 !== (u = e[Tn]) ? !!u : "RegExp" == jn(e));
  },
      Fn = Ye.exports,
      Ln = Ou,
      Nn = ju,
      zn = Qe.exports("species"),
      Mn = Ye.exports,
      In = function In(e, u, t) {
    var n,
        r = u.constructor;
    return r !== t && "function" == typeof r && (n = r.prototype) !== t.prototype && vn(n) && gn && gn(e, n), e;
  },
      Rn = Ou.f,
      Bn = _n.f,
      Hn = Dn,
      $n = xu,
      _Wn = Mn.RegExp,
      Gn = _Wn,
      qn = _Wn.prototype,
      Vn = /a/g,
      Qn = /a/g,
      Zn = new _Wn(Vn) !== Vn;

  if (ju && (!Zn || Au(function () {
    return Qn[Qe.exports("match")] = !1, _Wn(Vn) != Vn || _Wn(Qn) == Qn || "/a/i" != _Wn(Vn, "i");
  }))) {
    _Wn = function Wn(e, u) {
      var t = this instanceof _Wn,
          n = Hn(e),
          r = void 0 === u;
      return !t && n && e.constructor === _Wn && r ? e : In(Zn ? new Gn(n && !r ? e.source : e, u) : Gn((n = e instanceof _Wn) ? e.source : e, n && r ? $n.call(e) : u), t ? this : qn, _Wn);
    };

    for (var Jn = function Jn(e) {
      (e in _Wn) || Rn(_Wn, e, {
        configurable: !0,
        get: function get() {
          return Gn[e];
        },
        set: function set(u) {
          Gn[e] = u;
        }
      });
    }, Kn = Bn(Gn), Yn = 0; Kn.length > Yn;) {
      Jn(Kn[Yn++]);
    }

    qn.constructor = _Wn, _Wn.prototype = qn, Vu.exports(Mn, "RegExp", _Wn);
  }

  function Xn(e, u, t) {
    return t = t || "", "string" != typeof e && (e.global && t.indexOf("g") < 0 && (t += "g"), e.ignoreCase && t.indexOf("i") < 0 && (t += "i"), e.multiline && t.indexOf("m") < 0 && (t += "m"), e = e.source), new RegExp(e.replace(/#\{(\w+)\}/g, function (e, t) {
      var n = u[t] || "";
      return "string" != typeof n && (n = n.source), n;
    }), t);
  }

  On = Fn["RegExp"], Nn && On && !On[zn] && Ln.f(On, zn, {
    configurable: !0,
    get: function get() {
      return this;
    }
  });
  var er = /\x09-\x0D\x20\x85\xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000/,
      ur = Xn(/[#{spacesGroup}]/, {
    spacesGroup: er
  }),
      tr = Xn("(^|#{spaces})(\\$)(#{cashtag})(?=$|\\s|[#{punct}])", {
    cashtag: Xt,
    spaces: ur,
    punct: en
  }, "gi");

  function nr(e) {
    if (!e || -1 === e.indexOf("$")) return [];
    var u = [];
    return e.replace(tr, function (e, t, n, r, a, d) {
      var i = a + t.length,
          o = i + r.length + 1;
      u.push({
        cashtag: r,
        indices: [i, o]
      });
    }), u;
  }

  var rr = je,
      ar = Re,
      dr = Ge,
      ir = mu;
  kt("match", 1, function (e, u, t, n) {
    return [function (t) {
      var n = e(this),
          r = null == t ? void 0 : t[u];
      return void 0 !== r ? r.call(t, n) : new RegExp(t)[u](String(n));
    }, function (e) {
      var u = n(t, e, this);
      if (u.done) return u.value;
      var r = rr(e),
          a = String(this);
      if (!r.global) return ir(r, a);
      var d = r.unicode;
      r.lastIndex = 0;

      for (var i, o = [], c = 0; null !== (i = ir(r, a));) {
        var l = String(i[0]);
        o[c] = l, "" === l && (r.lastIndex = dr(a, ar(r.lastIndex), d)), c++;
      }

      return 0 === c ? null : o;
    }];
  });
  var or = /[#＃]/,
      cr = Xn(/^(?:#{hashSigns}|:\/\/)/, {
    hashSigns: or
  }),
      lr = Xn(RegExp("(?:(?:한국|香港|澳門|新加坡|台灣|台湾|中國|中国|გე|ລາວ|ไทย|ලංකා|ഭാരതം|ಭಾರತ|భారత్|சிங்கப்பூர்|இலங்கை|இந்தியா|ଭାରତ|ભારત|ਭਾਰਤ|ভাৰত|ভারত|বাংলা|भारोत|भारतम्|भारत|ڀارت|پاکستان|موريتانيا|مليسيا|مصر|قطر|فلسطين|عمان|عراق|سورية|سودان|تونس|بھارت|بارت|ایران|امارات|المغرب|السعودية|الجزائر|البحرين|الاردن|հայ|қаз|укр|срб|рф|мон|мкд|ею|бел|бг|ευ|ελ|zw|zm|za|yt|ye|ws|wf|vu|vn|vi|vg|ve|vc|va|uz|uy|us|um|uk|ug|ua|tz|tw|tv|tt|tr|tp|to|tn|tm|tl|tk|tj|th|tg|tf|td|tc|sz|sy|sx|sv|su|st|ss|sr|so|sn|sm|sl|sk|sj|si|sh|sg|se|sd|sc|sb|sa|rw|ru|rs|ro|re|qa|py|pw|pt|ps|pr|pn|pm|pl|pk|ph|pg|pf|pe|pa|om|nz|nu|nr|np|no|nl|ni|ng|nf|ne|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|mn|mm|ml|mk|mh|mg|mf|me|md|mc|ma|ly|lv|lu|lt|ls|lr|lk|li|lc|lb|la|kz|ky|kw|kr|kp|kn|km|ki|kh|kg|ke|jp|jo|jm|je|it|is|ir|iq|io|in|im|il|ie|id|hu|ht|hr|hn|hm|hk|gy|gw|gu|gt|gs|gr|gq|gp|gn|gm|gl|gi|gh|gg|gf|ge|gd|gb|ga|fr|fo|fm|fk|fj|fi|eu|et|es|er|eh|eg|ee|ec|dz|do|dm|dk|dj|de|cz|cy|cx|cw|cv|cu|cr|co|cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|bz|by|bw|bv|bt|bs|br|bq|bo|bn|bm|bl|bj|bi|bh|bg|bf|be|bd|bb|ba|az|ax|aw|au|at|as|ar|aq|ao|an|am|al|ai|ag|af|ae|ad|ac)(?=[^0-9a-zA-Z@+-]|$))")),
      sr = /\u202A-\u202E\u061C\u200E\u200F\u2066\u2067\u2068\u2069/,
      fr = /\uFFFE\uFEFF\uFFFF/;

  function pr(e, u) {
    return e.replace(/#\{(\w+)\}/g, function (e, t) {
      return u[t] || "";
    });
  }

  var hr = pr("#{punct}#{spacesGroup}#{invalidCharsGroup}#{directionalMarkersGroup}", {
    punct: en,
    spacesGroup: er,
    invalidCharsGroup: fr,
    directionalMarkersGroup: sr
  }),
      vr = Xn(/[^#{invalidDomainChars}]/, {
    invalidDomainChars: hr
  }),
      gr = Xn(/(?:(?:#{validDomainChars}(?:-|#{validDomainChars})*)?#{validDomainChars}\.)/, {
    validDomainChars: vr
  }),
      _r = Xn(RegExp("(?:(?:삼성|닷컴|닷넷|香格里拉|餐厅|食品|飞利浦|電訊盈科|集团|通販|购物|谷歌|诺基亚|联通|网络|网站|网店|网址|组织机构|移动|珠宝|点看|游戏|淡马锡|机构|書籍|时尚|新闻|政府|政务|招聘|手表|手机|我爱你|慈善|微博|广东|工行|家電|娱乐|天主教|大拿|大众汽车|在线|嘉里大酒店|嘉里|商标|商店|商城|公益|公司|八卦|健康|信息|佛山|企业|中文网|中信|世界|ポイント|ファッション|セール|ストア|コム|グーグル|クラウド|みんな|คอม|संगठन|नेट|कॉम|همراه|موقع|موبايلي|كوم|كاثوليك|عرب|شبكة|بيتك|بازار|العليان|ارامكو|اتصالات|ابوظبي|קום|сайт|рус|орг|онлайн|москва|ком|католик|дети|zuerich|zone|zippo|zip|zero|zara|zappos|yun|youtube|you|yokohama|yoga|yodobashi|yandex|yamaxun|yahoo|yachts|xyz|xxx|xperia|xin|xihuan|xfinity|xerox|xbox|wtf|wtc|wow|world|works|work|woodside|wolterskluwer|wme|winners|wine|windows|win|williamhill|wiki|wien|whoswho|weir|weibo|wedding|wed|website|weber|webcam|weatherchannel|weather|watches|watch|warman|wanggou|wang|walter|walmart|wales|vuelos|voyage|voto|voting|vote|volvo|volkswagen|vodka|vlaanderen|vivo|viva|vistaprint|vista|vision|visa|virgin|vip|vin|villas|viking|vig|video|viajes|vet|versicherung|vermögensberatung|vermögensberater|verisign|ventures|vegas|vanguard|vana|vacations|ups|uol|uno|university|unicom|uconnect|ubs|ubank|tvs|tushu|tunes|tui|tube|trv|trust|travelersinsurance|travelers|travelchannel|travel|training|trading|trade|toys|toyota|town|tours|total|toshiba|toray|top|tools|tokyo|today|tmall|tkmaxx|tjx|tjmaxx|tirol|tires|tips|tiffany|tienda|tickets|tiaa|theatre|theater|thd|teva|tennis|temasek|telefonica|telecity|tel|technology|tech|team|tdk|tci|taxi|tax|tattoo|tatar|tatamotors|target|taobao|talk|taipei|tab|systems|symantec|sydney|swiss|swiftcover|swatch|suzuki|surgery|surf|support|supply|supplies|sucks|style|study|studio|stream|store|storage|stockholm|stcgroup|stc|statoil|statefarm|statebank|starhub|star|staples|stada|srt|srl|spreadbetting|spot|sport|spiegel|space|soy|sony|song|solutions|solar|sohu|software|softbank|social|soccer|sncf|smile|smart|sling|skype|sky|skin|ski|site|singles|sina|silk|shriram|showtime|show|shouji|shopping|shop|shoes|shiksha|shia|shell|shaw|sharp|shangrila|sfr|sexy|sex|sew|seven|ses|services|sener|select|seek|security|secure|seat|search|scot|scor|scjohnson|science|schwarz|schule|school|scholarships|schmidt|schaeffler|scb|sca|sbs|sbi|saxo|save|sas|sarl|sapo|sap|sanofi|sandvikcoromant|sandvik|samsung|samsclub|salon|sale|sakura|safety|safe|saarland|ryukyu|rwe|run|ruhr|rugby|rsvp|room|rogers|rodeo|rocks|rocher|rmit|rip|rio|ril|rightathome|ricoh|richardli|rich|rexroth|reviews|review|restaurant|rest|republican|report|repair|rentals|rent|ren|reliance|reit|reisen|reise|rehab|redumbrella|redstone|red|recipes|realty|realtor|realestate|read|raid|radio|racing|qvc|quest|quebec|qpon|pwc|pub|prudential|pru|protection|property|properties|promo|progressive|prof|productions|prod|pro|prime|press|praxi|pramerica|post|porn|politie|poker|pohl|pnc|plus|plumbing|playstation|play|place|pizza|pioneer|pink|ping|pin|pid|pictures|pictet|pics|piaget|physio|photos|photography|photo|phone|philips|phd|pharmacy|pfizer|pet|pccw|pay|passagens|party|parts|partners|pars|paris|panerai|panasonic|pamperedchef|page|ovh|ott|otsuka|osaka|origins|orientexpress|organic|org|orange|oracle|open|ooo|onyourside|online|onl|ong|one|omega|ollo|oldnavy|olayangroup|olayan|okinawa|office|off|observer|obi|nyc|ntt|nrw|nra|nowtv|nowruz|now|norton|northwesternmutual|nokia|nissay|nissan|ninja|nikon|nike|nico|nhk|ngo|nfl|nexus|nextdirect|next|news|newholland|new|neustar|network|netflix|netbank|net|nec|nba|navy|natura|nationwide|name|nagoya|nadex|nab|mutuelle|mutual|museum|mtr|mtpc|mtn|msd|movistar|movie|mov|motorcycles|moto|moscow|mortgage|mormon|mopar|montblanc|monster|money|monash|mom|moi|moe|moda|mobily|mobile|mobi|mma|mls|mlb|mitsubishi|mit|mint|mini|mil|microsoft|miami|metlife|merckmsd|meo|menu|men|memorial|meme|melbourne|meet|media|med|mckinsey|mcdonalds|mcd|mba|mattel|maserati|marshalls|marriott|markets|marketing|market|map|mango|management|man|makeup|maison|maif|madrid|macys|luxury|luxe|lupin|lundbeck|ltda|ltd|lplfinancial|lpl|love|lotto|lotte|london|lol|loft|locus|locker|loans|loan|llp|llc|lixil|living|live|lipsy|link|linde|lincoln|limo|limited|lilly|like|lighting|lifestyle|lifeinsurance|life|lidl|liaison|lgbt|lexus|lego|legal|lefrak|leclerc|lease|lds|lawyer|law|latrobe|latino|lat|lasalle|lanxess|landrover|land|lancome|lancia|lancaster|lamer|lamborghini|ladbrokes|lacaixa|kyoto|kuokgroup|kred|krd|kpn|kpmg|kosher|komatsu|koeln|kiwi|kitchen|kindle|kinder|kim|kia|kfh|kerryproperties|kerrylogistics|kerryhotels|kddi|kaufen|juniper|juegos|jprs|jpmorgan|joy|jot|joburg|jobs|jnj|jmp|jll|jlc|jio|jewelry|jetzt|jeep|jcp|jcb|java|jaguar|iwc|iveco|itv|itau|istanbul|ist|ismaili|iselect|irish|ipiranga|investments|intuit|international|intel|int|insure|insurance|institute|ink|ing|info|infiniti|industries|inc|immobilien|immo|imdb|imamat|ikano|iinet|ifm|ieee|icu|ice|icbc|ibm|hyundai|hyatt|hughes|htc|hsbc|how|house|hotmail|hotels|hoteles|hot|hosting|host|hospital|horse|honeywell|honda|homesense|homes|homegoods|homedepot|holiday|holdings|hockey|hkt|hiv|hitachi|hisamitsu|hiphop|hgtv|hermes|here|helsinki|help|healthcare|health|hdfcbank|hdfc|hbo|haus|hangout|hamburg|hair|guru|guitars|guide|guge|gucci|guardian|group|grocery|gripe|green|gratis|graphics|grainger|gov|got|gop|google|goog|goodyear|goodhands|goo|golf|goldpoint|gold|godaddy|gmx|gmo|gmbh|gmail|globo|global|gle|glass|glade|giving|gives|gifts|gift|ggee|george|genting|gent|gea|gdn|gbiz|gay|garden|gap|games|game|gallup|gallo|gallery|gal|fyi|futbol|furniture|fund|fun|fujixerox|fujitsu|ftr|frontier|frontdoor|frogans|frl|fresenius|free|fox|foundation|forum|forsale|forex|ford|football|foodnetwork|food|foo|fly|flsmidth|flowers|florist|flir|flights|flickr|fitness|fit|fishing|fish|firmdale|firestone|fire|financial|finance|final|film|fido|fidelity|fiat|ferrero|ferrari|feedback|fedex|fast|fashion|farmers|farm|fans|fan|family|faith|fairwinds|fail|fage|extraspace|express|exposed|expert|exchange|everbank|events|eus|eurovision|etisalat|esurance|estate|esq|erni|ericsson|equipment|epson|epost|enterprises|engineering|engineer|energy|emerck|email|education|edu|edeka|eco|eat|earth|dvr|dvag|durban|dupont|duns|dunlop|duck|dubai|dtv|drive|download|dot|doosan|domains|doha|dog|dodge|doctor|docs|dnp|diy|dish|discover|discount|directory|direct|digital|diet|diamonds|dhl|dev|design|desi|dentist|dental|democrat|delta|deloitte|dell|delivery|degree|deals|dealer|deal|dds|dclk|day|datsun|dating|date|data|dance|dad|dabur|cyou|cymru|cuisinella|csc|cruises|cruise|crs|crown|cricket|creditunion|creditcard|credit|cpa|courses|coupons|coupon|country|corsica|coop|cool|cookingchannel|cooking|contractors|contact|consulting|construction|condos|comsec|computer|compare|company|community|commbank|comcast|com|cologne|college|coffee|codes|coach|clubmed|club|cloud|clothing|clinique|clinic|click|cleaning|claims|cityeats|city|citic|citi|citadel|cisco|circle|cipriani|church|chrysler|chrome|christmas|chloe|chintai|cheap|chat|chase|charity|channel|chanel|cfd|cfa|cern|ceo|center|ceb|cbs|cbre|cbn|cba|catholic|catering|cat|casino|cash|caseih|case|casa|cartier|cars|careers|career|care|cards|caravan|car|capitalone|capital|capetown|canon|cancerresearch|camp|camera|cam|calvinklein|call|cal|cafe|cab|bzh|buzz|buy|business|builders|build|bugatti|budapest|brussels|brother|broker|broadway|bridgestone|bradesco|box|boutique|bot|boston|bostik|bosch|boots|booking|book|boo|bond|bom|bofa|boehringer|boats|bnpparibas|bnl|bmw|bms|blue|bloomberg|blog|blockbuster|blanco|blackfriday|black|biz|bio|bingo|bing|bike|bid|bible|bharti|bet|bestbuy|best|berlin|bentley|beer|beauty|beats|bcn|bcg|bbva|bbt|bbc|bayern|bauhaus|basketball|baseball|bargains|barefoot|barclays|barclaycard|barcelona|bar|bank|band|bananarepublic|banamex|baidu|baby|azure|axa|aws|avianca|autos|auto|author|auspost|audio|audible|audi|auction|attorney|athleta|associates|asia|asda|arte|art|arpa|army|archi|aramco|arab|aquarelle|apple|app|apartments|aol|anz|anquan|android|analytics|amsterdam|amica|amfam|amex|americanfamily|americanexpress|alstom|alsace|ally|allstate|allfinanz|alipay|alibaba|alfaromeo|akdn|airtel|airforce|airbus|aigo|aig|agency|agakhan|africa|afl|afamilycompany|aetna|aero|aeg|adult|ads|adac|actor|active|aco|accountants|accountant|accenture|academy|abudhabi|abogado|able|abc|abbvie|abbott|abb|abarth|aarp|aaa|onion)(?=[^0-9a-zA-Z@+-]|$))")),
      br = /(?:xn--[\-0-9a-z]+)/,
      mr = Xn(/(?:(?:#{validDomainChars}(?:[_-]|#{validDomainChars})*)?#{validDomainChars}\.)/, {
    validDomainChars: vr
  }),
      yr = Xn(/(?:#{validSubdomain}*#{validDomainName}(?:#{validGTLD}|#{validCCTLD}|#{validPunycode}))/, {
    validDomainName: gr,
    validSubdomain: mr,
    validGTLD: _r,
    validCCTLD: lr,
    validPunycode: br
  }),
      xr = /[0-9]+/,
      wr = /\u0400-\u04FF/,
      kr = /\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u024F\u0253\u0254\u0256\u0257\u0259\u025B\u0263\u0268\u026F\u0272\u0289\u028B\u02BB\u0300-\u036F\u1E00-\u1EFF/,
      Ur = Xn(/[a-z#{cyrillicLettersAndMarks}0-9!\*';:=\+,\.\$\/%#\[\]\-\u2013_~@\|&#{latinAccentChars}]/i, {
    cyrillicLettersAndMarks: wr,
    latinAccentChars: kr
  }),
      Sr = Xn("\\((?:#{validGeneralUrlPathChars}+|(?:#{validGeneralUrlPathChars}*\\(#{validGeneralUrlPathChars}+\\)#{validGeneralUrlPathChars}*))\\)", {
    validGeneralUrlPathChars: Ur
  }, "i"),
      Cr = Xn(/[\+\-a-z#{cyrillicLettersAndMarks}0-9=_#\/#{latinAccentChars}]|(?:#{validUrlBalancedParens})/i, {
    cyrillicLettersAndMarks: wr,
    latinAccentChars: kr,
    validUrlBalancedParens: Sr
  }),
      Pr = Xn("(?:(?:#{validGeneralUrlPathChars}*(?:#{validUrlBalancedParens}#{validGeneralUrlPathChars}*)*#{validUrlPathEndingChars})|(?:@#{validGeneralUrlPathChars}+/))", {
    validGeneralUrlPathChars: Ur,
    validUrlBalancedParens: Sr,
    validUrlPathEndingChars: Cr
  }, "i"),
      Er = Xn(/(?:[^A-Za-z0-9@＠$#＃#{invalidCharsGroup}]|[#{directionalMarkersGroup}]|^)/, {
    invalidCharsGroup: fr,
    directionalMarkersGroup: sr
  }),
      Or = /[a-z0-9!?\*'@\(\);:&=\+\$\/%#\[\]\-_\.,~|]/i,
      Ar = /[a-z0-9\-_&=#\/]/i,
      jr = Xn("((#{validUrlPrecedingChars})((https?:\\/\\/)?(#{validDomain})(?::(#{validPortNumber}))?(\\/#{validUrlPath}*)?(\\?#{validUrlQueryChars}*#{validUrlQueryEndingChars})?))", {
    validUrlPrecedingChars: Er,
    validDomain: yr,
    validPortNumber: xr,
    validUrlPath: Pr,
    validUrlQueryChars: Or,
    validUrlQueryEndingChars: Ar
  }, "gi"),
      Tr = /[-_.\/]$/,
      Dr = je,
      Fr = rt,
      Lr = Qe.exports("species"),
      Nr = Dn,
      zr = je,
      Mr = function Mr(e, u) {
    var t,
        n = Dr(e).constructor;
    return void 0 === n || null == (t = Dr(n)[Lr]) ? u : Fr(t);
  },
      Ir = Ge,
      Rr = Re,
      Br = mu,
      Hr = Eu,
      $r = Au,
      Wr = Math.min,
      Gr = [].push,
      qr = 4294967295,
      Vr = !$r(function () {
    RegExp(qr, "y");
  });

  kt("split", 2, function (e, u, t, n) {
    var r;
    return r = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (e, u) {
      var n = String(this);
      if (void 0 === e && 0 === u) return [];
      if (!Nr(e)) return t.call(n, e, u);

      for (var r, a, d, i = [], o = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), c = 0, l = void 0 === u ? qr : u >>> 0, s = new RegExp(e.source, o + "g"); (r = Hr.call(s, n)) && !((a = s.lastIndex) > c && (i.push(n.slice(c, r.index)), r.length > 1 && r.index < n.length && Gr.apply(i, r.slice(1)), d = r[0].length, c = a, i.length >= l));) {
        s.lastIndex === r.index && s.lastIndex++;
      }

      return c === n.length ? !d && s.test("") || i.push("") : i.push(n.slice(c)), i.length > l ? i.slice(0, l) : i;
    } : "0".split(void 0, 0).length ? function (e, u) {
      return void 0 === e && 0 === u ? [] : t.call(this, e, u);
    } : t, [function (t, n) {
      var a = e(this),
          d = null == t ? void 0 : t[u];
      return void 0 !== d ? d.call(t, a, n) : r.call(String(a), t, n);
    }, function (e, u) {
      var a = n(r, e, this, u, r !== t);
      if (a.done) return a.value;
      var d = zr(e),
          i = String(this),
          o = Mr(d, RegExp),
          c = d.unicode,
          l = (d.ignoreCase ? "i" : "") + (d.multiline ? "m" : "") + (d.unicode ? "u" : "") + (Vr ? "y" : "g"),
          s = new o(Vr ? d : "^(?:" + d.source + ")", l),
          f = void 0 === u ? qr : u >>> 0;
      if (0 === f) return [];
      if (0 === i.length) return null === Br(s, i) ? [i] : [];

      for (var p = 0, h = 0, v = []; h < i.length;) {
        s.lastIndex = Vr ? h : 0;

        var g,
            _ = Br(s, Vr ? i : i.slice(h));

        if (null === _ || (g = Wr(Rr(s.lastIndex + (Vr ? 0 : h)), i.length)) === p) h = Ir(i, h, c);else {
          if (v.push(i.slice(p, h)), v.length === f) return v;

          for (var b = 1; b <= _.length - 1; b++) {
            if (v.push(_[b]), v.length === f) return v;
          }

          h = p = g;
        }
      }

      return v.push(i.slice(p)), v;
    }];
  });
  var Qr,
      Zr,
      Jr = {
    exports: {}
  };
  /*! https://mths.be/punycode v1.4.1 by @mathias */

  Qr = Jr, Zr = Jr.exports, function (e) {
    var u = Zr && !Zr.nodeType && Zr,
        t = Qr && !Qr.nodeType && Qr,
        n = "object" == typeof Ee && Ee;
    n.global !== n && n.window !== n && n.self !== n || (e = n);
    var r,
        a,
        d = 2147483647,
        i = 36,
        o = /^xn--/,
        c = /[^\x20-\x7E]/,
        l = /[\x2E\u3002\uFF0E\uFF61]/g,
        s = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    },
        f = Math.floor,
        p = String.fromCharCode;

    function h(e) {
      throw new RangeError(s[e]);
    }

    function v(e, u) {
      for (var t = e.length, n = []; t--;) {
        n[t] = u(e[t]);
      }

      return n;
    }

    function g(e, u) {
      var t = e.split("@"),
          n = "";
      return t.length > 1 && (n = t[0] + "@", e = t[1]), n + v((e = e.replace(l, ".")).split("."), u).join(".");
    }

    function _(e) {
      for (var u, t, n = [], r = 0, a = e.length; r < a;) {
        (u = e.charCodeAt(r++)) >= 55296 && u <= 56319 && r < a ? 56320 == (64512 & (t = e.charCodeAt(r++))) ? n.push(((1023 & u) << 10) + (1023 & t) + 65536) : (n.push(u), r--) : n.push(u);
      }

      return n;
    }

    function b(e) {
      return v(e, function (e) {
        var u = "";
        return e > 65535 && (u += p((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), u += p(e);
      }).join("");
    }

    function m(e, u) {
      return e + 22 + 75 * (e < 26) - ((0 != u) << 5);
    }

    function y(e, u, t) {
      var n = 0;

      for (e = t ? f(e / 700) : e >> 1, e += f(e / u); e > 455; n += i) {
        e = f(e / 35);
      }

      return f(n + 36 * e / (e + 38));
    }

    function x(e) {
      var u,
          t,
          n,
          r,
          a,
          o,
          c,
          l,
          s,
          p,
          v,
          g = [],
          _ = e.length,
          m = 0,
          x = 128,
          w = 72;

      for ((t = e.lastIndexOf("-")) < 0 && (t = 0), n = 0; n < t; ++n) {
        e.charCodeAt(n) >= 128 && h("not-basic"), g.push(e.charCodeAt(n));
      }

      for (r = t > 0 ? t + 1 : 0; r < _;) {
        for (a = m, o = 1, c = i; r >= _ && h("invalid-input"), ((l = (v = e.charCodeAt(r++)) - 48 < 10 ? v - 22 : v - 65 < 26 ? v - 65 : v - 97 < 26 ? v - 97 : i) >= i || l > f((d - m) / o)) && h("overflow"), m += l * o, !(l < (s = c <= w ? 1 : c >= w + 26 ? 26 : c - w)); c += i) {
          o > f(d / (p = i - s)) && h("overflow"), o *= p;
        }

        w = y(m - a, u = g.length + 1, 0 == a), f(m / u) > d - x && h("overflow"), x += f(m / u), m %= u, g.splice(m++, 0, x);
      }

      return b(g);
    }

    function w(e) {
      var u,
          t,
          n,
          r,
          a,
          o,
          c,
          l,
          s,
          v,
          g,
          b,
          x,
          w,
          k,
          U = [];

      for (b = (e = _(e)).length, u = 128, t = 0, a = 72, o = 0; o < b; ++o) {
        (g = e[o]) < 128 && U.push(p(g));
      }

      for (n = r = U.length, r && U.push("-"); n < b;) {
        for (c = d, o = 0; o < b; ++o) {
          (g = e[o]) >= u && g < c && (c = g);
        }

        for (c - u > f((d - t) / (x = n + 1)) && h("overflow"), t += (c - u) * x, u = c, o = 0; o < b; ++o) {
          if ((g = e[o]) < u && ++t > d && h("overflow"), g == u) {
            for (l = t, s = i; !(l < (v = s <= a ? 1 : s >= a + 26 ? 26 : s - a)); s += i) {
              k = l - v, w = i - v, U.push(p(m(v + k % w, 0))), l = f(k / w);
            }

            U.push(p(m(l, 0))), a = y(t, x, n == r), t = 0, ++n;
          }
        }

        ++t, ++u;
      }

      return U.join("");
    }

    if (r = {
      version: "1.4.1",
      ucs2: {
        decode: _,
        encode: b
      },
      decode: x,
      encode: w,
      toASCII: function toASCII(e) {
        return g(e, function (e) {
          return c.test(e) ? "xn--" + w(e) : e;
        });
      },
      toUnicode: function toUnicode(e) {
        return g(e, function (e) {
          return o.test(e) ? x(e.slice(4).toLowerCase()) : e;
        });
      }
    }, u && t) {
      if (Qr.exports == u) t.exports = r;else for (a in r) {
        r.hasOwnProperty(a) && (u[a] = r[a]);
      }
    } else e.punycode = r;
  }(Ee);

  var Kr = Jr.exports,
      Yr = Xn(/(?:(?:[\-a-z0-9#{latinAccentChars}]+)\.)+(?:#{validGTLD}|#{validCCTLD}|#{validPunycode})/gi, {
    latinAccentChars: kr,
    validGTLD: _r,
    validCCTLD: lr,
    validPunycode: br
  }),
      Xr = function Xr(e) {
    if ("xn--" !== e.substring(0, 4) || e.match(Yr)) {
      for (var u = e.split("."), t = 0; t < u.length; t++) {
        var n = u[t],
            r = Kr.toASCII(n);
        if (r.length < 1 || r.length > 63) return;
      }

      return u.join(".");
    }
  },
      ea = Xn(/^https?:\/\/t\.co\/([a-z0-9]+)(?:\?#{validUrlQueryChars}*#{validUrlQueryEndingChars})?/, {
    validUrlQueryChars: Or,
    validUrlQueryEndingChars: Ar
  }, "i"),
      ua = "https://",
      ta = {
    extractUrlsWithoutProtocol: !0
  },
      na = function na(e) {
    var u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ta;
    if (!e || (u.extractUrlsWithoutProtocol ? !e.match(/\./) : !e.match(/:/))) return [];

    for (var t = [], n = function n() {
      var e = RegExp.$2,
          n = RegExp.$3,
          r = RegExp.$4,
          a = RegExp.$5,
          d = RegExp.$7,
          i = jr.lastIndex,
          o = i - n.length;
      if (!ra(n, r || ua, a)) return "continue";

      if (r) {
        if (n.match(ea)) {
          var c = RegExp.$1;
          if (c && c.length > 40) return "continue";
          n = RegExp.lastMatch, i = o + n.length;
        }

        t.push({
          url: n,
          indices: [o, i]
        });
      } else {
        if (!u.extractUrlsWithoutProtocol || e.match(Tr)) return "continue";
        var l = null,
            s = 0;
        if (a.replace(Yr, function (e) {
          var u = a.indexOf(e, s);
          s = u + e.length, l = {
            url: e,
            indices: [o + u, o + s]
          }, t.push(l);
        }), null == l) return "continue";
        d && (l.url = n.replace(a, l.url), l.indices[1] = i);
      }
    }; jr.exec(e);) {
      n();
    }

    return t;
  },
      ra = function ra(e, u, t) {
    var n = e.length,
        r = Xr(t);
    return !(!r || !r.length) && (n = n + r.length - t.length, u.length + n <= 4096);
  },
      aa = pt,
      da = rt,
      ia = Fe,
      oa = Au,
      ca = [].sort,
      la = [1, 2, 3];

  function sa(e) {
    e.sort(function (e, u) {
      return e.indices[0] - u.indices[0];
    });

    for (var u = e[0], t = 1; t < e.length; t++) {
      u.indices[1] > e[t].indices[0] ? (e.splice(t, 1), t--) : u = e[t];
    }
  }

  aa(aa.P + aa.F * (oa(function () {
    la.sort(void 0);
  }) || !oa(function () {
    la.sort(null);
  }) || !Qt(ca)), "Array", {
    sort: function sort(e) {
      return void 0 === e ? ca.call(ia(this)) : ca.call(ia(this), da(e));
    }
  });

  var fa = /\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\uddfd\ude80-\ude9c\udea0-\uded0\udee0\udf00-\udf1f\udf30-\udf40\udf42-\udf49\udf50-\udf7a\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf]|\ud801[\udc00-\udc9d\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00-\ude03\ude05\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude33\ude38-\ude3a\ude3f\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee6\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48]|\ud804[\udc00-\udc46\udc7f-\udcba\udcd0-\udce8\udd00-\udd34\udd50-\udd73\udd76\udd80-\uddc4\uddda\ude00-\ude11\ude13-\ude37\udeb0-\udeea\udf01-\udf03\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3c-\udf44\udf47\udf48\udf4b-\udf4d\udf57\udf5d-\udf63\udf66-\udf6c\udf70-\udf74]|\ud805[\udc80-\udcc5\udcc7\udd80-\uddb5\uddb8-\uddc0\ude00-\ude40\ude44\ude80-\udeb7]|\ud806[\udca0-\udcdf\udcff\udec0-\udef8]|\ud808[\udc00-\udf98]|\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud81a[\udc00-\ude38\ude40-\ude5e\uded0-\udeed\udef0-\udef4\udf00-\udf36\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\udf00-\udf44\udf50-\udf7e\udf8f-\udf9f]|\ud82c[\udc00\udc01]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9d\udc9e]|\ud834[\udd65-\udd69\udd6d-\udd72\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud83a[\udc00-\udcc4\udcd0-\udcd6]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud840[\udc00-\udfff]|\ud841[\udc00-\udfff]|\ud842[\udc00-\udfff]|\ud843[\udc00-\udfff]|\ud844[\udc00-\udfff]|\ud845[\udc00-\udfff]|\ud846[\udc00-\udfff]|\ud847[\udc00-\udfff]|\ud848[\udc00-\udfff]|\ud849[\udc00-\udfff]|\ud84a[\udc00-\udfff]|\ud84b[\udc00-\udfff]|\ud84c[\udc00-\udfff]|\ud84d[\udc00-\udfff]|\ud84e[\udc00-\udfff]|\ud84f[\udc00-\udfff]|\ud850[\udc00-\udfff]|\ud851[\udc00-\udfff]|\ud852[\udc00-\udfff]|\ud853[\udc00-\udfff]|\ud854[\udc00-\udfff]|\ud855[\udc00-\udfff]|\ud856[\udc00-\udfff]|\ud857[\udc00-\udfff]|\ud858[\udc00-\udfff]|\ud859[\udc00-\udfff]|\ud85a[\udc00-\udfff]|\ud85b[\udc00-\udfff]|\ud85c[\udc00-\udfff]|\ud85d[\udc00-\udfff]|\ud85e[\udc00-\udfff]|\ud85f[\udc00-\udfff]|\ud860[\udc00-\udfff]|\ud861[\udc00-\udfff]|\ud862[\udc00-\udfff]|\ud863[\udc00-\udfff]|\ud864[\udc00-\udfff]|\ud865[\udc00-\udfff]|\ud866[\udc00-\udfff]|\ud867[\udc00-\udfff]|\ud868[\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|\ud86a[\udc00-\udfff]|\ud86b[\udc00-\udfff]|\ud86c[\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]|\ud87e[\udc00-\ude1d]|\udb40[\udd00-\uddef]/,
      pa = /A-Za-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0300-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u0483-\u052f\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u05d0-\u05ea\u05f0-\u05f2\u0610-\u061a\u0620-\u065f\u066e-\u06d3\u06d5-\u06dc\u06df-\u06e8\u06ea-\u06ef\u06fa-\u06fc\u06ff\u0710-\u074a\u074d-\u07b1\u07ca-\u07f5\u07fa\u0800-\u082d\u0840-\u085b\u08a0-\u08b2\u08e4-\u0963\u0971-\u0983\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bc-\u09c4\u09c7\u09c8\u09cb-\u09ce\u09d7\u09dc\u09dd\u09df-\u09e3\u09f0\u09f1\u0a01-\u0a03\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a59-\u0a5c\u0a5e\u0a70-\u0a75\u0a81-\u0a83\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abc-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ad0\u0ae0-\u0ae3\u0b01-\u0b03\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3c-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5c\u0b5d\u0b5f-\u0b63\u0b71\u0b82\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd0\u0bd7\u0c00-\u0c03\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c58\u0c59\u0c60-\u0c63\u0c81-\u0c83\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbc-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0cde\u0ce0-\u0ce3\u0cf1\u0cf2\u0d01-\u0d03\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d-\u0d44\u0d46-\u0d48\u0d4a-\u0d4e\u0d57\u0d60-\u0d63\u0d7a-\u0d7f\u0d82\u0d83\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e01-\u0e3a\u0e40-\u0e4e\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb9\u0ebb-\u0ebd\u0ec0-\u0ec4\u0ec6\u0ec8-\u0ecd\u0edc-\u0edf\u0f00\u0f18\u0f19\u0f35\u0f37\u0f39\u0f3e-\u0f47\u0f49-\u0f6c\u0f71-\u0f84\u0f86-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u103f\u1050-\u108f\u109a-\u109d\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u135d-\u135f\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16f1-\u16f8\u1700-\u170c\u170e-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176c\u176e-\u1770\u1772\u1773\u1780-\u17d3\u17d7\u17dc\u17dd\u180b-\u180d\u1820-\u1877\u1880-\u18aa\u18b0-\u18f5\u1900-\u191e\u1920-\u192b\u1930-\u193b\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a1b\u1a20-\u1a5e\u1a60-\u1a7c\u1a7f\u1aa7\u1ab0-\u1abe\u1b00-\u1b4b\u1b6b-\u1b73\u1b80-\u1baf\u1bba-\u1bf3\u1c00-\u1c37\u1c4d-\u1c4f\u1c5a-\u1c7d\u1cd0-\u1cd2\u1cd4-\u1cf6\u1cf8\u1cf9\u1d00-\u1df5\u1dfc-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u20d0-\u20f0\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2183\u2184\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d7f-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2de0-\u2dff\u2e2f\u3005\u3006\u302a-\u302f\u3031-\u3035\u303b\u303c\u3041-\u3096\u3099\u309a\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua672\ua674-\ua67d\ua67f-\ua69d\ua69f-\ua6e5\ua6f0\ua6f1\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua7ad\ua7b0\ua7b1\ua7f7-\ua827\ua840-\ua873\ua880-\ua8c4\ua8e0-\ua8f7\ua8fb\ua90a-\ua92d\ua930-\ua953\ua960-\ua97c\ua980-\ua9c0\ua9cf\ua9e0-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa36\uaa40-\uaa4d\uaa60-\uaa76\uaa7a-\uaac2\uaadb-\uaadd\uaae0-\uaaef\uaaf2-\uaaf6\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab5f\uab64\uab65\uabc0-\uabea\uabec\uabed\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf870-\uf87f\uf882\uf884-\uf89f\uf8b8\uf8c1-\uf8d6\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe00-\ufe0f\ufe20-\ufe2d\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc/,
      ha = /[\uD800-\uDBFF][\uDC00-\uDFFF]/gm,
      va = Xn(/(?:[#{bmpLetterAndMarks}]|(?=#{nonBmpCodePairs})(?:#{astralLetterAndMarks}))/, {
    bmpLetterAndMarks: pa,
    nonBmpCodePairs: ha,
    astralLetterAndMarks: fa
  }),
      ga = /\ud801[\udca0-\udca9]|\ud804[\udc66-\udc6f\udcf0-\udcf9\udd36-\udd3f\uddd0-\uddd9\udef0-\udef9]|\ud805[\udcd0-\udcd9\ude50-\ude59\udec0-\udec9]|\ud806[\udce0-\udce9]|\ud81a[\ude60-\ude69\udf50-\udf59]|\ud835[\udfce-\udfff]/,
      _a = /0-9\u0660-\u0669\u06f0-\u06f9\u07c0-\u07c9\u0966-\u096f\u09e6-\u09ef\u0a66-\u0a6f\u0ae6-\u0aef\u0b66-\u0b6f\u0be6-\u0bef\u0c66-\u0c6f\u0ce6-\u0cef\u0d66-\u0d6f\u0de6-\u0def\u0e50-\u0e59\u0ed0-\u0ed9\u0f20-\u0f29\u1040-\u1049\u1090-\u1099\u17e0-\u17e9\u1810-\u1819\u1946-\u194f\u19d0-\u19d9\u1a80-\u1a89\u1a90-\u1a99\u1b50-\u1b59\u1bb0-\u1bb9\u1c40-\u1c49\u1c50-\u1c59\ua620-\ua629\ua8d0-\ua8d9\ua900-\ua909\ua9d0-\ua9d9\ua9f0-\ua9f9\uaa50-\uaa59\uabf0-\uabf9\uff10-\uff19/,
      ba = /_\u200c\u200d\ua67e\u05be\u05f3\u05f4\uff5e\u301c\u309b\u309c\u30a0\u30fb\u3003\u0f0b\u0f0c\xb7/,
      ma = Xn(/(?:[#{bmpLetterAndMarks}#{bmpNumerals}#{hashtagSpecialChars}]|(?=#{nonBmpCodePairs})(?:#{astralLetterAndMarks}|#{astralNumerals}))/, {
    bmpLetterAndMarks: pa,
    bmpNumerals: _a,
    hashtagSpecialChars: ba,
    nonBmpCodePairs: ha,
    astralLetterAndMarks: fa,
    astralNumerals: ga
  }),
      ya = /(?:[^\uD800-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF])/,
      xa = Xn(/(?:^|\uFE0E|\uFE0F|$|(?!#{hashtagAlphaNumeric}|&)#{codePoint})/, {
    codePoint: ya,
    hashtagAlphaNumeric: ma
  }),
      wa = Xn(/(#{hashtagBoundary})(#{hashSigns})(?!\uFE0F|\u20E3)(#{hashtagAlphaNumeric}*#{hashtagAlpha}#{hashtagAlphaNumeric}*)/gi, {
    hashtagBoundary: xa,
    hashSigns: or,
    hashtagAlphaNumeric: ma,
    hashtagAlpha: va
  }),
      ka = function ka(e, u) {
    if (u || (u = {
      checkUrlOverlap: !0
    }), !e || !e.match(or)) return [];
    var t = [];

    if (e.replace(wa, function (e, u, n, r, a, d) {
      if (!d.slice(a + e.length).match(cr)) {
        var i = a + u.length,
            o = i + r.length + 1;
        t.push({
          hashtag: r,
          indices: [i, o]
        });
      }
    }), u.checkUrlOverlap) {
      var n = na(e);

      if (n.length > 0) {
        var r = t.concat(n);
        sa(r), t = [];

        for (var a = 0; a < r.length; a++) {
          r[a].hashtag && t.push(r[a]);
        }
      }
    }

    return t;
  },
      Ua = /[@＠]/,
      Sa = Xn(/^(?:#{atSigns}|[#{latinAccentChars}]|:\/\/)/, {
    atSigns: Ua,
    latinAccentChars: kr
  }),
      Ca = /(?:^|[^a-zA-Z0-9_!#$%&*@＠]|(?:^|[^a-zA-Z0-9_+~.-])(?:rt|RT|rT|Rt):?)/,
      Pa = Xn("(#{validMentionPrecedingChars})(#{atSigns})([a-zA-Z0-9_]{1,20})(/[a-zA-Z][a-zA-Z0-9_-]{0,24})?", {
    validMentionPrecedingChars: Ca,
    atSigns: Ua
  }, "g");

  function Ea(e) {
    if (!e || !e.match(Ua)) return [];
    var u = [];
    return e.replace(Pa, function (e, t, n, r, a, d, i) {
      if (!i.slice(d + e.length).match(Sa)) {
        a = a || "";
        var o = d + t.length,
            c = o + r.length + a.length + 1;
        u.push({
          screenName: r,
          listSlug: a,
          indices: [o, c]
        });
      }
    }), u;
  }

  function Oa(e, u) {
    var t = na(e, u).concat(Ea(e)).concat(ka(e, {
      checkUrlOverlap: !1
    })).concat(nr(e));
    return 0 == t.length ? [] : (sa(t), t);
  }

  function Aa(e) {
    var u = {};

    for (var t in e) {
      e.hasOwnProperty(t) && (u[t] = e[t]);
    }

    return u;
  }

  var ja = {
    disabled: !0,
    readonly: !0,
    multiple: !0,
    checked: !0
  },
      Ta = {
    urlClass: !0,
    listClass: !0,
    usernameClass: !0,
    hashtagClass: !0,
    cashtagClass: !0,
    usernameUrlBase: !0,
    listUrlBase: !0,
    hashtagUrlBase: !0,
    cashtagUrlBase: !0,
    usernameUrlBlock: !0,
    listUrlBlock: !0,
    hashtagUrlBlock: !0,
    linkUrlBlock: !0,
    usernameIncludeSymbol: !0,
    suppressLists: !0,
    suppressNoFollow: !0,
    targetBlank: !0,
    suppressDataScreenName: !0,
    urlEntities: !0,
    symbolTag: !0,
    textWithSymbolTag: !0,
    urlTarget: !0,
    invisibleTagAttrs: !0,
    linkAttributeBlock: !0,
    linkTextBlock: !0,
    htmlEscapeNonEntities: !0
  };

  function Da(e) {
    var u = {};

    for (var t in e) {
      var n = e[t];
      Ta[t] || (ja[t] && (n = n ? t : null), null != n && (u[t] = n));
    }

    return u;
  }

  var Fa = {
    "&": "&amp;",
    ">": "&gt;",
    "<": "&lt;",
    '"': "&quot;",
    "'": "&#39;"
  };

  function La(e) {
    return e && e.replace(/[&"'><]/g, function (e) {
      return Fa[e];
    });
  }

  ju && "g" != /./g.flags && Ou.f(RegExp.prototype, "flags", {
    configurable: !0,
    get: xu
  });

  var Na = je,
      za = xu,
      Ma = ju,
      Ia = "toString",
      Ra = /./.toString,
      Ba = function Ba(e) {
    Vu.exports(RegExp.prototype, Ia, e, !0);
  };

  Au(function () {
    return "/a/b" != Ra.call({
      source: "a",
      flags: "b"
    });
  }) ? Ba(function () {
    var e = Na(this);
    return "/".concat(e.source, "/", "flags" in e ? e.flags : !Ma && e instanceof RegExp ? za.call(e) : void 0);
  }) : Ra.name != Ia && Ba(function () {
    return Ra.call(this);
  });
  var Ha = Date.prototype,
      $a = "Invalid Date",
      Wa = "toString",
      Ga = Ha.toString,
      qa = Ha.getTime;
  new Date(NaN) + "" != $a && Vu.exports(Ha, Wa, function () {
    var e = qa.call(this);
    return e == e ? Ga.call(this) : $a;
  });
  var Va = gu,
      Qa = {};
  Qa[Qe.exports("toStringTag")] = "z", Qa + "" != "[object z]" && Vu.exports(Object.prototype, "toString", function () {
    return "[object " + Va(this) + "]";
  }, !0);
  var Za = {
    disabled: !0,
    readonly: !0,
    multiple: !0,
    checked: !0
  };

  function Ja(e) {
    var u = "";

    for (var t in e) {
      var n = e[t];
      Za[t] && (n = n ? t : null), null != n && (u += " ".concat(La(t), '="').concat(La(n.toString()), '"'));
    }

    return u;
  }

  function Ka(e, u, t, n) {
    return n.suppressNoFollow || (t.rel = "nofollow"), n.linkAttributeBlock && n.linkAttributeBlock(e, t), n.linkTextBlock && (u = n.linkTextBlock(e, u)), pr("<a#{attr}>#{text}</a>", {
      text: u,
      attr: Ja(t)
    });
  }

  function Ya(e, u, t, n, r) {
    var a = r.symbolTag ? "<".concat(r.symbolTag, ">").concat(u, "</").concat(r.symbolTag, ">") : u;
    t = La(t);
    var d = r.textWithSymbolTag ? "<".concat(r.textWithSymbolTag, ">").concat(t, "</").concat(r.textWithSymbolTag, ">") : t;
    return r.usernameIncludeSymbol || !u.match(Ua) ? Ka(e, a + d, n, r) : a + Ka(e, d, n, r);
  }

  function Xa(e, u, t) {
    var n = La(e.cashtag),
        r = Aa(t.htmlAttrs || {});
    return r.href = t.cashtagUrlBase + n, r.title = "$".concat(n), r.class = t.cashtagClass, t.targetBlank && (r.target = "_blank"), Ya(e, "$", n, r, t);
  }

  var ed = /[\u0600-\u06FF]|[\u0750-\u077F]|[\u0590-\u05FF]|[\uFE70-\uFEFF]/gm;

  function ud(e, u, t) {
    var n = u.substring(e.indices[0], e.indices[0] + 1),
        r = La(e.hashtag),
        a = Aa(t.htmlAttrs || {});
    return a.href = t.hashtagUrlBase + r, a.title = "#".concat(r), a.class = t.hashtagClass, r.charAt(0).match(ed) && (a.class += " rtl"), t.targetBlank && (a.target = "_blank"), Ya(e, n, r, a, t);
  }

  function td(e, u) {
    var t = e.display_url,
        n = e.expanded_url,
        r = t.replace(/…/g, "");

    if (-1 != n.indexOf(r)) {
      var a = n.indexOf(r),
          d = {
        displayUrlSansEllipses: r,
        beforeDisplayUrl: n.substr(0, a),
        afterDisplayUrl: n.substr(a + r.length),
        precedingEllipsis: t.match(/^…/) ? "…" : "",
        followingEllipsis: t.match(/…$/) ? "…" : ""
      };

      for (var i in d) {
        d.hasOwnProperty(i) && (d[i] = La(d[i]));
      }

      return d.invisible = u.invisibleTagAttrs, pr("<span class='tco-ellipsis'>#{precedingEllipsis}<span #{invisible}>&nbsp;</span></span><span #{invisible}>#{beforeDisplayUrl}</span><span class='js-display-url'>#{displayUrlSansEllipses}</span><span #{invisible}>#{afterDisplayUrl}</span><span class='tco-ellipsis'><span #{invisible}>&nbsp;</span>#{followingEllipsis}</span>", d);
    }

    return t;
  }

  var nd = /^https?:\/\//i;

  function rd(e, u, t) {
    var n = e.url,
        r = La(n),
        a = t.urlEntities && t.urlEntities[n] || e;
    a.display_url && (r = td(a, t));
    var d = Aa(t.htmlAttrs || {});
    return n.match(nd) || (n = "http://".concat(n)), d.href = n, t.targetBlank && (d.target = "_blank"), t.urlClass && (d.class = t.urlClass), t.urlTarget && (d.target = t.urlTarget), !t.title && a.display_url && (d.title = a.expanded_url), Ka(e, r, d, t);
  }

  function ad(e, u, t) {
    var n = u.substring(e.indices[0], e.indices[0] + 1),
        r = La(e.screenName),
        a = La(e.listSlug),
        d = e.listSlug && !t.suppressLists,
        i = Aa(t.htmlAttrs || {});
    return i.class = d ? t.listClass : t.usernameClass, i.href = d ? t.listUrlBase + r + a : t.usernameUrlBase + r, d || t.suppressDataScreenName || (i["data-screen-name"] = r), t.targetBlank && (i.target = "_blank"), Ya(e, n, d ? r + a : r, i, t);
  }

  function dd(e, u, t) {
    var n, r;

    if ((t = Aa(t || {})).hashtagClass = t.hashtagClass || "tweet-url hashtag", t.hashtagUrlBase = t.hashtagUrlBase || "https://twitter.com/search?q=%23", t.cashtagClass = t.cashtagClass || "tweet-url cashtag", t.cashtagUrlBase = t.cashtagUrlBase || "https://twitter.com/search?q=%24", t.listClass = t.listClass || "tweet-url list-slug", t.usernameClass = t.usernameClass || "tweet-url username", t.usernameUrlBase = t.usernameUrlBase || "https://twitter.com/", t.listUrlBase = t.listUrlBase || "https://twitter.com/", t.htmlAttrs = Da(t), t.invisibleTagAttrs = t.invisibleTagAttrs || "style='position:absolute;left:-9999px;'", t.urlEntities) {
      for (n = {}, o = 0, r = t.urlEntities.length; o < r; o++) {
        n[t.urlEntities[o].url] = t.urlEntities[o];
      }

      t.urlEntities = n;
    }

    var a = "",
        d = 0;
    u.sort(function (e, u) {
      return e.indices[0] - u.indices[0];
    });

    for (var i = t.htmlEscapeNonEntities ? La : function (e) {
      return e;
    }, o = 0; o < u.length; o++) {
      var c = u[o];
      a += i(e.substring(d, c.indices[0])), c.url ? a += rd(c, 0, t) : c.hashtag ? a += ud(c, e, t) : c.screenName ? a += ad(c, e, t) : c.cashtag && (a += Xa(c, 0, t)), d = c.indices[1];
    }

    return a += i(e.substring(d, e.length));
  }

  var id = function id(e, u, t) {
    if (0 !== u.length) {
      var n = 0,
          r = 0;
      u.sort(function (e, u) {
        return e.indices[0] - u.indices[0];
      });

      for (var a = 0, d = u[0]; n < e.length;) {
        if (d.indices[0] === (t ? n : r)) {
          var i = d.indices[1] - d.indices[0];
          if (d.indices[0] = t ? r : n, d.indices[1] = d.indices[0] + i, ++a === u.length) break;
          d = u[a];
        }

        var o = e.charCodeAt(n);
        o >= 55296 && o <= 56319 && n < e.length - 1 && (o = e.charCodeAt(n + 1)) >= 56320 && o <= 57343 && n++, r++, n++;
      }
    }
  };

  function od(e, u) {
    id(e, u, !1);
  }

  var cd = {
    version1: {
      version: 1,
      maxWeightedTweetLength: 140,
      scale: 1,
      defaultWeight: 1,
      transformedURLLength: 23,
      ranges: []
    },
    version2: {
      version: 2,
      maxWeightedTweetLength: 280,
      scale: 100,
      defaultWeight: 200,
      transformedURLLength: 23,
      ranges: [{
        start: 0,
        end: 4351,
        weight: 100
      }, {
        start: 8192,
        end: 8205,
        weight: 100
      }, {
        start: 8208,
        end: 8223,
        weight: 100
      }, {
        start: 8242,
        end: 8247,
        weight: 100
      }]
    },
    version3: {
      version: 3,
      maxWeightedTweetLength: 280,
      scale: 100,
      defaultWeight: 200,
      emojiParsingEnabled: !0,
      transformedURLLength: 23,
      ranges: [{
        start: 0,
        end: 4351,
        weight: 100
      }, {
        start: 8192,
        end: 8205,
        weight: 100
      }, {
        start: 8208,
        end: 8223,
        weight: 100
      }, {
        start: 8242,
        end: 8247,
        weight: 100
      }]
    },
    defaults: {
      version: 3,
      maxWeightedTweetLength: 280,
      scale: 100,
      defaultWeight: 200,
      emojiParsingEnabled: !0,
      transformedURLLength: 23,
      ranges: [{
        start: 0,
        end: 4351,
        weight: 100
      }, {
        start: 8192,
        end: 8205,
        weight: 100
      }, {
        start: 8208,
        end: 8223,
        weight: 100
      }, {
        start: 8242,
        end: 8247,
        weight: 100
      }]
    }
  };

  function ld(e) {
    for (var u = [], t = ka(e), n = 0; n < t.length; n++) {
      u.push(t[n].hashtag);
    }

    return u;
  }

  function sd(e) {
    for (var u, t = [], n = Ea(e), r = 0; r < n.length; r++) {
      "" === (u = n[r]).listSlug && t.push({
        screenName: u.screenName,
        indices: u.indices
      });
    }

    return t;
  }

  function fd(e) {
    for (var u = [], t = sd(e), n = 0; n < t.length; n++) {
      var r = t[n].screenName;
      u.push(r);
    }

    return u;
  }

  var pd = Xn(/^(?:#{spaces})*#{atSigns}([a-zA-Z0-9_]{1,20})/, {
    atSigns: Ua,
    spaces: ur
  });

  var hd = Ve,
      vd = Array.isArray || function (e) {
    return "Array" == hd(e);
  };

  pt(pt.S, "Array", {
    isArray: vd
  });

  var gd = function gd(e, u) {
    var t = u.defaultWeight,
        n = u.ranges,
        r = t,
        a = e.charCodeAt(0);
    if (Array.isArray(n)) for (var d = 0, i = n.length; d < i; d++) {
      var o = n[d];

      if (a >= o.start && a <= o.end) {
        r = o.weight;
        break;
      }
    }
    return r;
  };

  var _d = rt,
      bd = Fe,
      md = Nt,
      yd = Re,
      xd = pt,
      wd = function wd(e, u, t, n, r) {
    _d(u);

    var a = bd(e),
        d = md(a),
        i = yd(a.length),
        o = r ? i - 1 : 0,
        c = r ? -1 : 1;
    if (t < 2) for (;;) {
      if (o in d) {
        n = d[o], o += c;
        break;
      }

      if (o += c, r ? o < 0 : i <= o) throw TypeError("Reduce of empty array with no initial value");
    }

    for (; r ? o >= 0 : i > o; o += c) {
      o in d && (n = u(n, d[o], o, a));
    }

    return n;
  };

  xd(xd.P + xd.F * !Qt([].reduce, !0), "Array", {
    reduce: function reduce(e) {
      return wd(this, e, arguments.length, arguments[1], !1);
    }
  });
  var kd = Qe.exports("unscopables"),
      Ud = Array.prototype;
  null == Ud[kd] && qu(Ud, kd, {});

  var Sd = {},
      Cd = Sn,
      Pd = Cn,
      Ed = Object.keys || function (e) {
    return Cd(e, Pd);
  },
      Od = Ou,
      Ad = je,
      jd = Ed,
      Td = ju ? Object.defineProperties : function (e, u) {
    Ad(e);

    for (var t, n = jd(u), r = n.length, a = 0; r > a;) {
      Od.f(e, t = n[a++], u[t]);
    }

    return e;
  },
      Dd = Ye.exports.document,
      Fd = Dd && Dd.documentElement,
      Ld = je,
      Nd = Td,
      zd = Cn,
      Md = yn("IE_PROTO"),
      Id = function Id() {},
      _Rd = function Rd() {
    var e,
        u = Lu("iframe"),
        t = zd.length;

    for (u.style.display = "none", Fd.appendChild(u), u.src = "javascript:", (e = u.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _Rd = e.F; t--;) {
      delete _Rd.prototype[zd[t]];
    }

    return _Rd();
  },
      Bd = Object.create || function (e, u) {
    var t;
    return null !== e ? (Id.prototype = Ld(e), t = new Id(), Id.prototype = null, t[Md] = e) : t = _Rd(), void 0 === u ? t : Nd(t, u);
  },
      Hd = Ou.f,
      $d = Zu,
      Wd = Qe.exports("toStringTag"),
      Gd = function Gd(e, u, t) {
    e && !$d(e = t ? e : e.prototype, Wd) && Hd(e, Wd, {
      configurable: !0,
      value: u
    });
  },
      qd = Bd,
      Vd = $u,
      Qd = Gd,
      Zd = {};

  qu(Zd, Qe.exports("iterator"), function () {
    return this;
  });

  var Jd = Zu,
      Kd = Fe,
      Yd = yn("IE_PROTO"),
      Xd = Object.prototype,
      ei = Object.getPrototypeOf || function (e) {
    return e = Kd(e), Jd(e, Yd) ? e[Yd] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? Xd : null;
  },
      ui = pt,
      ti = Vu.exports,
      ni = qu,
      ri = Sd,
      ai = function ai(e, u, t) {
    e.prototype = qd(Zd, {
      next: Vd(1, t)
    }), Qd(e, u + " Iterator");
  },
      di = Gd,
      ii = ei,
      oi = Qe.exports("iterator"),
      ci = !([].keys && "next" in [].keys()),
      li = "keys",
      si = "values",
      fi = function fi() {
    return this;
  },
      pi = function pi(e, u, t, n, r, a, d) {
    ai(t, u, n);

    var i,
        o,
        c,
        l = function l(e) {
      if (!ci && e in h) return h[e];

      switch (e) {
        case li:
        case si:
          return function () {
            return new t(this, e);
          };
      }

      return function () {
        return new t(this, e);
      };
    },
        s = u + " Iterator",
        f = r == si,
        p = !1,
        h = e.prototype,
        v = h[oi] || h["@@iterator"] || r && h[r],
        g = v || l(r),
        _ = r ? f ? l("entries") : g : void 0,
        b = "Array" == u && h.entries || v;

    if (b && (c = ii(b.call(new e()))) !== Object.prototype && c.next && (di(c, s, !0), "function" != typeof c[oi] && ni(c, oi, fi)), f && v && v.name !== si && (p = !0, g = function g() {
      return v.call(this);
    }), (ci || p || !h[oi]) && ni(h, oi, g), ri[u] = g, ri[s] = fi, r) if (i = {
      values: f ? g : l(si),
      keys: a ? g : l(li),
      entries: _
    }, d) for (o in i) {
      o in h || ti(h, o, i[o]);
    } else ui(ui.P + ui.F * (ci || p), u, i);
    return i;
  },
      hi = function hi(e) {
    Ud[kd][e] = !0;
  },
      vi = function vi(e, u) {
    return {
      value: u,
      done: !!e
    };
  },
      gi = Sd,
      _i = It,
      bi = pi(Array, "Array", function (e, u) {
    this._t = _i(e), this._i = 0, this._k = u;
  }, function () {
    var e = this._t,
        u = this._k,
        t = this._i++;
    return !e || t >= e.length ? (this._t = void 0, vi(1)) : vi(0, "keys" == u ? t : "values" == u ? e[t] : [t, e[t]]);
  }, "values");

  gi.Arguments = gi.Array, hi("keys"), hi("values"), hi("entries");

  for (var mi = bi, yi = Ed, xi = Vu.exports, wi = Ye.exports, ki = qu, Ui = Sd, Si = Qe.exports, Ci = Si("iterator"), Pi = Si("toStringTag"), Ei = Ui.Array, Oi = {
    CSSRuleList: !0,
    CSSStyleDeclaration: !1,
    CSSValueList: !1,
    ClientRectList: !1,
    DOMRectList: !1,
    DOMStringList: !1,
    DOMTokenList: !0,
    DataTransferItemList: !1,
    FileList: !1,
    HTMLAllCollection: !1,
    HTMLCollection: !1,
    HTMLFormElement: !1,
    HTMLSelectElement: !1,
    MediaList: !0,
    MimeTypeArray: !1,
    NamedNodeMap: !1,
    NodeList: !0,
    PaintRequestList: !1,
    Plugin: !1,
    PluginArray: !1,
    SVGLengthList: !1,
    SVGNumberList: !1,
    SVGPathSegList: !1,
    SVGPointList: !1,
    SVGStringList: !1,
    SVGTransformList: !1,
    SourceBufferList: !1,
    StyleSheetList: !0,
    TextTrackCueList: !1,
    TextTrackList: !1,
    TouchList: !1
  }, Ai = yi(Oi), ji = 0; ji < Ai.length; ji++) {
    var Ti,
        Di = Ai[ji],
        Fi = Oi[Di],
        Li = wi[Di],
        Ni = Li && Li.prototype;
    if (Ni && (Ni[Ci] || ki(Ni, Ci, Ei), Ni[Pi] || ki(Ni, Pi, Di), Ui[Di] = Ei, Fi)) for (Ti in mi) {
      Ni[Ti] || xi(Ni, Ti, mi[Ti], !0);
    }
  }

  var zi = pt,
      Mi = Je.exports,
      Ii = Au,
      Ri = Fe,
      Bi = Ed;
  !function (e, u) {
    var t = (Mi.Object || {})[e] || Object[e],
        n = {};
    n[e] = u(t), zi(zi.S + zi.F * Ii(function () {
      t(1);
    }), "Object", n);
  }("keys", function () {
    return function (e) {
      return Bi(Ri(e));
    };
  });
  var Hi = Xn(/[#{invalidCharsGroup}]/, {
    invalidCharsGroup: fr
  });

  function $i(e) {
    return Hi.test(e);
  }

  var Wi = {},
      Gi = {};
  Object.defineProperty(Gi, "__esModule", {
    value: !0
  }), Gi.default = /(?:\ud83d[\udc68\udc69])(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddb0-\uddb3])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\uddb5\uddb6\uddb8\uddb9\uddd1-\udddd]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a-\udc6d\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\udeeb\udeec\udef4-\udef9]|\ud83e[\udd10-\udd17\udd1d\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd40-\udd45\udd47-\udd70\udd73-\udd76\udd7a\udd7c-\udda2\uddb4\uddb7\uddc0-\uddc2\uddd0\uddde-\uddff]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g, Object.defineProperty(Wi, "__esModule", {
    value: !0
  }), Wi.TypeName = void 0;

  var qi = Wi.parse = function (e, u) {
    var t = u && u.assetType ? u.assetType : "svg",
        n = u && u.buildUrl ? u.buildUrl : function (e, u) {
      return "png" === u ? "https://twemoji.maxcdn.com/2/72x72/" + e + ".png" : "https://twemoji.maxcdn.com/2/svg/" + e + ".svg";
    },
        r = [];
    Qi.default.lastIndex = 0;

    for (;;) {
      var a = Qi.default.exec(e);
      if (!a) break;
      var d = a[0],
          i = Xi(Yi(d)).join("-");
      r.push({
        url: i ? n(i, t) : "",
        indices: [a.index, Qi.default.lastIndex],
        text: d,
        type: Zi
      });
    }

    return r;
  };

  Wi.toCodePoints = Xi;
  var Vi,
      Qi = (Vi = Gi) && Vi.__esModule ? Vi : {
    default: Vi
  };
  var Zi = Wi.TypeName = "emoji";

  var Ji = /\uFE0F/g,
      Ki = String.fromCharCode(8205),
      Yi = function Yi(e) {
    return e.indexOf(Ki) < 0 ? e.replace(Ji, "") : e;
  };

  function Xi(e) {
    for (var u = [], t = 0, n = 0, r = 0; r < e.length;) {
      t = e.charCodeAt(r++), n ? (u.push((65536 + (n - 55296 << 10) + (t - 56320)).toString(16)), n = 0) : t > 55296 && t <= 56319 ? n = t : u.push(t.toString(16));
    }

    return u;
  }

  var eo = function eo() {
    for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : cd.defaults, t = Object.keys(u).length ? u : cd.defaults, n = t.defaultWeight, r = t.emojiParsingEnabled, a = t.scale, d = t.maxWeightedTweetLength, i = t.transformedURLLength, o = "function" == typeof String.prototype.normalize ? e.normalize() : e, c = uo(na(o)), l = r ? uo(qi(o)) : [], s = o.length, f = 0, p = 0, h = !0, v = 0; v < s; v++) {
      if (c[v]) {
        var g = c[v],
            _ = g.url;
        g.indices, f += i * a, v += _.length - 1;
      } else if (r && l[v]) {
        var b = l[v],
            m = b.text;
        b.indices, f += n, v += m.length - 1;
      } else v += to(o, v) ? 1 : 0, f += gd(o.charAt(v), t);

      h && (h = !$i(o.substring(v, v + 1))), h && f <= d * a && (p = v);
    }

    f /= a, h = h && f > 0 && f <= d;
    var y = Math.floor(f / d * 1e3),
        x = e.length - o.length;
    return {
      weightedLength: f,
      valid: h,
      permillage: y,
      validRangeStart: 0,
      validRangeEnd: p += x,
      displayRangeStart: 0,
      displayRangeEnd: e.length > 0 ? e.length - 1 : 0
    };
  },
      uo = function uo(e) {
    return e.reduce(function (e, u) {
      return e[u.indices[0]] = u, e;
    }, {});
  },
      to = function to(e, u) {
    if (u < e.length - 1) {
      var t = e.charCodeAt(u),
          n = e.charCodeAt(u + 1);
      return 55296 <= t && t <= 56319 && 56320 <= n && n <= 57343;
    }

    return !1;
  },
      no = function no(e) {
    var u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : cd.defaults;
    return eo(e, u).weightedLength;
  };

  function ro(e) {
    return e.replace(ha, " ").length;
  }

  function ao(e) {
    for (var u, t, n = e.split("<"), r = [], a = 0; a < n.length; a += 1) {
      if (t = n[a]) {
        u = t.split(">");

        for (var d = 0; d < u.length; d += 1) {
          r.push(u[d]);
        }
      } else r.push("");
    }

    return r;
  }

  var io = pt;
  io(io.S + io.F * !ju, "Object", {
    defineProperty: Ou.f
  });
  var oo = pt;
  oo(oo.S + oo.F * !ju, "Object", {
    defineProperties: Td
  });
  var co = {};
  co.f = Object.getOwnPropertySymbols;

  var lo = _n,
      so = co,
      fo = je,
      po = Ye.exports.Reflect,
      ho = po && po.ownKeys || function (e) {
    var u = lo.f(fo(e)),
        t = so.f;
    return t ? u.concat(t(e)) : u;
  },
      vo = Ou,
      go = $u,
      _o = function _o(e, u, t) {
    u in e ? vo.f(e, u, go(0, t)) : e[u] = t;
  },
      bo = ho,
      mo = It,
      yo = un,
      xo = _o;

  pt(pt.S, "Object", {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(e) {
      for (var u, t, n = mo(e), r = yo.f, a = bo(n), d = {}, i = 0; a.length > i;) {
        void 0 !== (t = r(n, u = a[i++])) && xo(d, u, t);
      }

      return d;
    }
  });

  var wo = Oe,
      ko = vd,
      Uo = Qe.exports("species"),
      So = function So(e) {
    var u;
    return ko(e) && ("function" != typeof (u = e.constructor) || u !== Array && !ko(u.prototype) || (u = void 0), wo(u) && null === (u = u[Uo]) && (u = void 0)), void 0 === u ? Array : u;
  },
      Co = dt,
      Po = Nt,
      Eo = Fe,
      Oo = Re,
      Ao = function Ao(e, u) {
    return new (So(e))(u);
  },
      jo = function jo(e, u) {
    var t = 1 == e,
        n = 2 == e,
        r = 3 == e,
        a = 4 == e,
        d = 6 == e,
        i = 5 == e || d,
        o = u || Ao;
    return function (u, c, l) {
      for (var s, f, p = Eo(u), h = Po(p), v = Co(c, l, 3), g = Oo(h.length), _ = 0, b = t ? o(u, g) : n ? o(u, 0) : void 0; g > _; _++) {
        if ((i || _ in h) && (f = v(s = h[_], _, p), e)) if (t) b[_] = f;else if (f) switch (e) {
          case 3:
            return !0;

          case 5:
            return s;

          case 6:
            return _;

          case 2:
            b.push(s);
        } else if (a) return !1;
      }

      return d ? -1 : r || a ? a : b;
    };
  },
      To = pt,
      Do = jo(0),
      Fo = Qt([].forEach, !0);

  To(To.P + To.F * !Fo, "Array", {
    forEach: function forEach(e) {
      return Do(this, e, arguments[1]);
    }
  });
  var Lo = pt,
      No = jo(2);
  Lo(Lo.P + Lo.F * !Qt([].filter, !0), "Array", {
    filter: function filter(e) {
      return No(this, e, arguments[1]);
    }
  });

  var zo = {
    exports: {}
  },
      Mo = du("meta"),
      Io = Oe,
      Ro = Zu,
      Bo = Ou.f,
      Ho = 0,
      $o = Object.isExtensible || function () {
    return !0;
  },
      Wo = !Au(function () {
    return $o(Object.preventExtensions({}));
  }),
      Go = function Go(e) {
    Bo(e, Mo, {
      value: {
        i: "O" + ++Ho,
        w: {}
      }
    });
  },
      qo = zo.exports = {
    KEY: Mo,
    NEED: !1,
    fastKey: function fastKey(e, u) {
      if (!Io(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

      if (!Ro(e, Mo)) {
        if (!$o(e)) return "F";
        if (!u) return "E";
        Go(e);
      }

      return e[Mo].i;
    },
    getWeak: function getWeak(e, u) {
      if (!Ro(e, Mo)) {
        if (!$o(e)) return !0;
        if (!u) return !1;
        Go(e);
      }

      return e[Mo].w;
    },
    onFreeze: function onFreeze(e) {
      return Wo && qo.NEED && $o(e) && !Ro(e, Mo) && Go(e), e;
    }
  },
      Vo = {};

  Vo.f = Qe.exports;
  var Qo = Ye.exports,
      Zo = Je.exports,
      Jo = Vo,
      Ko = Ou.f,
      Yo = Ed,
      Xo = co,
      ec = tn,
      uc = {},
      tc = It,
      nc = _n.f,
      rc = {}.toString,
      ac = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  uc.f = function (e) {
    return ac && "[object Window]" == rc.call(e) ? function (e) {
      try {
        return nc(e);
      } catch (u) {
        return ac.slice();
      }
    }(e) : nc(tc(e));
  };

  var dc = Ye.exports,
      ic = Zu,
      oc = ju,
      cc = pt,
      lc = Vu.exports,
      sc = zo.exports.KEY,
      fc = Au,
      pc = Ze.exports,
      hc = Gd,
      vc = du,
      gc = Qe.exports,
      _c = Vo,
      bc = function bc(e) {
    var u = Zo.Symbol || (Zo.Symbol = Qo.Symbol || {});
    "_" == e.charAt(0) || e in u || Ko(u, e, {
      value: Jo.f(e)
    });
  },
      mc = function mc(e) {
    var u = Yo(e),
        t = Xo.f;
    if (t) for (var n, r = t(e), a = ec.f, d = 0; r.length > d;) {
      a.call(e, n = r[d++]) && u.push(n);
    }
    return u;
  },
      yc = vd,
      xc = je,
      wc = Oe,
      kc = Fe,
      Uc = It,
      Sc = Mu,
      Cc = $u,
      Pc = Bd,
      Ec = uc,
      Oc = un,
      Ac = co,
      jc = Ou,
      Tc = Ed,
      Dc = Oc.f,
      Fc = jc.f,
      Lc = Ec.f,
      _Nc = dc.Symbol,
      zc = dc.JSON,
      Mc = zc && zc.stringify,
      Ic = gc("_hidden"),
      Rc = gc("toPrimitive"),
      Bc = {}.propertyIsEnumerable,
      Hc = pc("symbol-registry"),
      $c = pc("symbols"),
      Wc = pc("op-symbols"),
      Gc = Object.prototype,
      qc = "function" == typeof _Nc && !!Ac.f,
      Vc = dc.QObject,
      Qc = !Vc || !Vc.prototype || !Vc.prototype.findChild,
      Zc = oc && fc(function () {
    return 7 != Pc(Fc({}, "a", {
      get: function get() {
        return Fc(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (e, u, t) {
    var n = Dc(Gc, u);
    n && delete Gc[u], Fc(e, u, t), n && e !== Gc && Fc(Gc, u, n);
  } : Fc,
      Jc = function Jc(e) {
    var u = $c[e] = Pc(_Nc.prototype);
    return u._k = e, u;
  },
      Kc = qc && "symbol" == typeof _Nc.iterator ? function (e) {
    return "symbol" == typeof e;
  } : function (e) {
    return e instanceof _Nc;
  },
      Yc = function Yc(e, u, t) {
    return e === Gc && Yc(Wc, u, t), xc(e), u = Sc(u, !0), xc(t), ic($c, u) ? (t.enumerable ? (ic(e, Ic) && e[Ic][u] && (e[Ic][u] = !1), t = Pc(t, {
      enumerable: Cc(0, !1)
    })) : (ic(e, Ic) || Fc(e, Ic, Cc(1, {})), e[Ic][u] = !0), Zc(e, u, t)) : Fc(e, u, t);
  },
      Xc = function Xc(e, u) {
    xc(e);

    for (var t, n = mc(u = Uc(u)), r = 0, a = n.length; a > r;) {
      Yc(e, t = n[r++], u[t]);
    }

    return e;
  },
      el = function el(e) {
    var u = Bc.call(this, e = Sc(e, !0));
    return !(this === Gc && ic($c, e) && !ic(Wc, e)) && (!(u || !ic(this, e) || !ic($c, e) || ic(this, Ic) && this[Ic][e]) || u);
  },
      ul = function ul(e, u) {
    if (e = Uc(e), u = Sc(u, !0), e !== Gc || !ic($c, u) || ic(Wc, u)) {
      var t = Dc(e, u);
      return !t || !ic($c, u) || ic(e, Ic) && e[Ic][u] || (t.enumerable = !0), t;
    }
  },
      tl = function tl(e) {
    for (var u, t = Lc(Uc(e)), n = [], r = 0; t.length > r;) {
      ic($c, u = t[r++]) || u == Ic || u == sc || n.push(u);
    }

    return n;
  },
      nl = function nl(e) {
    for (var u, t = e === Gc, n = Lc(t ? Wc : Uc(e)), r = [], a = 0; n.length > a;) {
      !ic($c, u = n[a++]) || t && !ic(Gc, u) || r.push($c[u]);
    }

    return r;
  };

  qc || (lc((_Nc = function Nc() {
    if (this instanceof _Nc) throw TypeError("Symbol is not a constructor!");

    var e = vc(arguments.length > 0 ? arguments[0] : void 0),
        u = function u(t) {
      this === Gc && u.call(Wc, t), ic(this, Ic) && ic(this[Ic], e) && (this[Ic][e] = !1), Zc(this, e, Cc(1, t));
    };

    return oc && Qc && Zc(Gc, e, {
      configurable: !0,
      set: u
    }), Jc(e);
  }).prototype, "toString", function () {
    return this._k;
  }), Oc.f = ul, jc.f = Yc, _n.f = Ec.f = tl, tn.f = el, Ac.f = nl, oc && lc(Gc, "propertyIsEnumerable", el, !0), _c.f = function (e) {
    return Jc(gc(e));
  }), cc(cc.G + cc.W + cc.F * !qc, {
    Symbol: _Nc
  });

  for (var rl = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), al = 0; rl.length > al;) {
    gc(rl[al++]);
  }

  for (var dl = Tc(gc.store), il = 0; dl.length > il;) {
    bc(dl[il++]);
  }

  cc(cc.S + cc.F * !qc, "Symbol", {
    for: function _for(e) {
      return ic(Hc, e += "") ? Hc[e] : Hc[e] = _Nc(e);
    },
    keyFor: function keyFor(e) {
      if (!Kc(e)) throw TypeError(e + " is not a symbol!");

      for (var u in Hc) {
        if (Hc[u] === e) return u;
      }
    },
    useSetter: function useSetter() {
      Qc = !0;
    },
    useSimple: function useSimple() {
      Qc = !1;
    }
  }), cc(cc.S + cc.F * !qc, "Object", {
    create: function create(e, u) {
      return void 0 === u ? Pc(e) : Xc(Pc(e), u);
    },
    defineProperty: Yc,
    defineProperties: Xc,
    getOwnPropertyDescriptor: ul,
    getOwnPropertyNames: tl,
    getOwnPropertySymbols: nl
  });
  var ol = fc(function () {
    Ac.f(1);
  });

  function cl(e, u, t) {
    return u in e ? Object.defineProperty(e, u, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[u] = t, e;
  }

  function ll(e, u) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      u && (n = n.filter(function (u) {
        return Object.getOwnPropertyDescriptor(e, u).enumerable;
      })), t.push.apply(t, n);
    }

    return t;
  }

  function sl(e) {
    for (var u = 1; u < arguments.length; u++) {
      var t = null != arguments[u] ? arguments[u] : {};
      u % 2 ? ll(t, !0).forEach(function (u) {
        cl(e, u, t[u]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ll(t).forEach(function (u) {
        Object.defineProperty(e, u, Object.getOwnPropertyDescriptor(t, u));
      });
    }

    return e;
  }

  function fl(e) {
    var u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : cd.defaults;
    if (!e) return "empty";
    var t = sl({}, cd.defaults, {}, u),
        n = t.maxWeightedTweetLength;
    return no(e, t) > n ? "too_long" : !!$i(e) && "invalid_characters";
  }

  cc(cc.S + cc.F * ol, "Object", {
    getOwnPropertySymbols: function getOwnPropertySymbols(e) {
      return Ac.f(kc(e));
    }
  }), zc && cc(cc.S + cc.F * (!qc || fc(function () {
    var e = _Nc();

    return "[null]" != Mc([e]) || "{}" != Mc({
      a: e
    }) || "{}" != Mc(Object(e));
  })), "JSON", {
    stringify: function stringify(e) {
      for (var u, t, n = [e], r = 1; arguments.length > r;) {
        n.push(arguments[r++]);
      }

      if (t = u = n[1], (wc(u) || void 0 !== e) && !Kc(e)) return yc(u) || (u = function u(e, _u2) {
        if ("function" == typeof t && (_u2 = t.call(this, e, _u2)), !Kc(_u2)) return _u2;
      }), n[1] = u, Mc.apply(zc, n);
    }
  }), _Nc.prototype[Rc] || qu(_Nc.prototype, Rc, _Nc.prototype.valueOf), hc(_Nc, "Symbol"), hc(Math, "Math", !0), hc(dc.JSON, "JSON", !0);
  var pl = Xn(/^#{validMentionOrList}$/, {
    validMentionOrList: Pa
  });

  var hl = /[a-z\u0400-\u04FF0-9\-._~]/i,
      vl = /(?:%[0-9a-f]{2})/i,
      gl = /[!$&'()*+,;=]/i,
      _l = Xn("(?:#{validateUrlUnreserved}|#{validateUrlPctEncoded}|#{validateUrlSubDelims}|:)*", {
    validateUrlUnreserved: hl,
    validateUrlPctEncoded: vl,
    validateUrlSubDelims: gl
  }, "i"),
      bl = /(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?)/i,
      ml = /(?:[a-z](?:[a-z0-9\-]*[a-z0-9])?)/i,
      yl = /(?:[a-z0-9](?:[a-z0-9_\-]*[a-z0-9])?)/i,
      xl = Xn(/(?:(?:#{validateUrlSubDomainSegment}\.)*(?:#{validateUrlDomainSegment}\.)#{validateUrlDomainTld})/i, {
    validateUrlSubDomainSegment: yl,
    validateUrlDomainSegment: bl,
    validateUrlDomainTld: ml
  }),
      wl = /(?:[0-9]|(?:[1-9][0-9])|(?:1[0-9]{2})|(?:2[0-4][0-9])|(?:25[0-5]))/i,
      kl = Xn(/(?:#{validateUrlDecOctet}(?:\.#{validateUrlDecOctet}){3})/i, {
    validateUrlDecOctet: wl
  }),
      Ul = /(?:\[[a-f0-9:\.]+\])/i,
      Sl = Xn("(?:#{validateUrlIpv4}|#{validateUrlIpv6})", {
    validateUrlIpv4: kl,
    validateUrlIpv6: Ul
  }, "i"),
      Cl = Xn("(?:#{validateUrlIp}|#{validateUrlDomain})", {
    validateUrlIp: Sl,
    validateUrlDomain: xl
  }, "i"),
      Pl = /[0-9]{1,5}/,
      El = Xn("(?:(#{validateUrlUserinfo})@)?(#{validateUrlHost})(?::(#{validateUrlPort}))?", {
    validateUrlUserinfo: _l,
    validateUrlHost: Cl,
    validateUrlPort: Pl
  }, "i"),
      Ol = Xn("(?:#{validateUrlUnreserved}|#{validateUrlPctEncoded}|#{validateUrlSubDelims}|[:|@])", {
    validateUrlUnreserved: hl,
    validateUrlPctEncoded: vl,
    validateUrlSubDelims: gl
  }, "i"),
      Al = Xn(/(#{validateUrlPchar}|\/|\?)*/i, {
    validateUrlPchar: Ol
  }),
      jl = Xn(/(\/#{validateUrlPchar}*)*/i, {
    validateUrlPchar: Ol
  }),
      Tl = Xn(/(#{validateUrlPchar}|\/|\?)*/i, {
    validateUrlPchar: Ol
  }),
      Dl = /(?:[a-z][a-z0-9+\-.]*)/i,
      Fl = Xn("^(?:([^:/?#]+):\\/\\/)?([^/?#]*)([^?#]*)(?:\\?([^#]*))?(?:#(.*))?$", "i"),
      Ll = /(?:(?:[a-z0-9]|[^\u0000-\u007f])(?:(?:[a-z0-9_\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i,
      Nl = /(?:(?:[a-z0-9]|[^\u0000-\u007f])(?:(?:[a-z0-9\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i,
      zl = /(?:(?:[a-z]|[^\u0000-\u007f])(?:(?:[a-z0-9\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i,
      Ml = Xn(/(?:(?:#{validateUrlUnicodeSubDomainSegment}\.)*(?:#{validateUrlUnicodeDomainSegment}\.)#{validateUrlUnicodeDomainTld})/i, {
    validateUrlUnicodeSubDomainSegment: Ll,
    validateUrlUnicodeDomainSegment: Nl,
    validateUrlUnicodeDomainTld: zl
  }),
      Il = Xn("(?:#{validateUrlIp}|#{validateUrlUnicodeDomain})", {
    validateUrlIp: Sl,
    validateUrlUnicodeDomain: Ml
  }, "i"),
      Rl = Xn("(?:(#{validateUrlUserinfo})@)?(#{validateUrlUnicodeHost})(?::(#{validateUrlPort}))?", {
    validateUrlUserinfo: _l,
    validateUrlUnicodeHost: Il,
    validateUrlPort: Pl
  }, "i");

  function Bl(e, u, t) {
    return t ? !e || e.match(u) && RegExp["$&"] === e : "string" == typeof e && e.match(u) && RegExp["$&"] === e;
  }

  var Hl = {
    astralLetterAndMarks: fa,
    astralNumerals: ga,
    atSigns: Ua,
    bmpLetterAndMarks: pa,
    bmpNumerals: _a,
    cashtag: Xt,
    codePoint: ya,
    cyrillicLettersAndMarks: wr,
    endHashtagMatch: cr,
    endMentionMatch: Sa,
    extractUrl: jr,
    hashSigns: or,
    hashtagAlpha: va,
    hashtagAlphaNumeric: ma,
    hashtagBoundary: xa,
    hashtagSpecialChars: ba,
    invalidChars: Hi,
    invalidCharsGroup: fr,
    invalidDomainChars: hr,
    invalidUrlWithoutProtocolPrecedingChars: Tr,
    latinAccentChars: kr,
    nonBmpCodePairs: ha,
    punct: en,
    rtlChars: ed,
    spaces: ur,
    spacesGroup: er,
    urlHasHttps: /^https:\/\//i,
    urlHasProtocol: nd,
    validAsciiDomain: Yr,
    validateUrlAuthority: El,
    validateUrlDecOctet: wl,
    validateUrlDomain: xl,
    validateUrlDomainSegment: bl,
    validateUrlDomainTld: ml,
    validateUrlFragment: Al,
    validateUrlHost: Cl,
    validateUrlIp: Sl,
    validateUrlIpv4: kl,
    validateUrlIpv6: Ul,
    validateUrlPath: jl,
    validateUrlPchar: Ol,
    validateUrlPctEncoded: vl,
    validateUrlPort: Pl,
    validateUrlQuery: Tl,
    validateUrlScheme: Dl,
    validateUrlSubDelims: gl,
    validateUrlSubDomainSegment: yl,
    validateUrlUnencoded: Fl,
    validateUrlUnicodeAuthority: Rl,
    validateUrlUnicodeDomain: Ml,
    validateUrlUnicodeDomainSegment: Nl,
    validateUrlUnicodeDomainTld: zl,
    validateUrlUnicodeHost: Il,
    validateUrlUnicodeSubDomainSegment: Ll,
    validateUrlUnreserved: hl,
    validateUrlUserinfo: _l,
    validCashtag: tr,
    validCCTLD: lr,
    validDomain: yr,
    validDomainChars: vr,
    validDomainName: gr,
    validGeneralUrlPathChars: Ur,
    validGTLD: _r,
    validHashtag: wa,
    validMentionOrList: Pa,
    validMentionPrecedingChars: Ca,
    validPortNumber: xr,
    validPunycode: br,
    validReply: pd,
    validSubdomain: mr,
    validTcoUrl: ea,
    validUrlBalancedParens: Sr,
    validUrlPath: Pr,
    validUrlPathEndingChars: Cr,
    validUrlPrecedingChars: Er,
    validUrlQueryChars: Or,
    validUrlQueryEndingChars: Ar
  },
      $l = $e(!0);
  pi(String, "String", function (e) {
    this._t = String(e), this._i = 0;
  }, function () {
    var e,
        u = this._t,
        t = this._i;
    return t >= u.length ? {
      value: void 0,
      done: !0
    } : (e = $l(u, t), this._i += e.length, {
      value: e,
      done: !1
    });
  });

  var Wl = je,
      Gl = Sd,
      ql = Qe.exports("iterator"),
      Vl = Array.prototype,
      Ql = gu,
      Zl = Qe.exports("iterator"),
      Jl = Sd,
      Kl = Je.exports.getIteratorMethod = function (e) {
    if (null != e) return e[Zl] || e["@@iterator"] || Jl[Ql(e)];
  },
      Yl = Qe.exports("iterator"),
      Xl = !1;

  try {
    var es = [7][Yl]();
    es.return = function () {
      Xl = !0;
    }, Array.from(es, function () {
      throw 2;
    });
  } catch (_s) {}

  var us = dt,
      ts = pt,
      ns = Fe,
      rs = function rs(e, u, t, n) {
    try {
      return n ? u(Wl(t)[0], t[1]) : u(t);
    } catch (_s) {
      var r = e.return;
      throw void 0 !== r && Wl(r.call(e)), _s;
    }
  },
      as = function as(e) {
    return void 0 !== e && (Gl.Array === e || Vl[ql] === e);
  },
      ds = Re,
      is = _o,
      os = Kl;

  ts(ts.S + ts.F * !function (e, u) {
    if (!u && !Xl) return !1;
    var t = !1;

    try {
      var n = [7],
          r = n[Yl]();
      r.next = function () {
        return {
          done: t = !0
        };
      }, n[Yl] = function () {
        return r;
      }, e(n);
    } catch (_s) {}

    return t;
  }(function (e) {
    Array.from(e);
  }), "Array", {
    from: function from(e) {
      var u,
          t,
          n,
          r,
          a = ns(e),
          d = "function" == typeof this ? this : Array,
          i = arguments.length,
          o = i > 1 ? arguments[1] : void 0,
          c = void 0 !== o,
          l = 0,
          s = os(a);
      if (c && (o = us(o, i > 2 ? arguments[2] : void 0, 2)), null == s || d == Array && as(s)) for (t = new d(u = ds(a.length)); u > l; l++) {
        is(t, l, c ? o(a[l], l) : a[l]);
      } else for (r = s.call(a), t = new d(); !(n = r.next()).done; l++) {
        is(t, l, c ? rs(r, o, [n.value, l], !0) : n.value);
      }
      return t.length = l, t;
    }
  });
  var cs = {
    autoLink: function autoLink(e, u) {
      return dd(e, Oa(e, {
        extractUrlsWithoutProtocol: !1
      }), u);
    },
    autoLinkCashtags: function autoLinkCashtags(e, u) {
      return dd(e, nr(e), u);
    },
    autoLinkEntities: dd,
    autoLinkHashtags: function autoLinkHashtags(e, u) {
      return dd(e, ka(e), u);
    },
    autoLinkUrlsCustom: function autoLinkUrlsCustom(e, u) {
      return dd(e, na(e, {
        extractUrlsWithoutProtocol: !1
      }), u);
    },
    autoLinkUsernamesOrLists: function autoLinkUsernamesOrLists(e, u) {
      return dd(e, Ea(e), u);
    },
    autoLinkWithJSON: function autoLinkWithJSON(e, u, t) {
      if (u.user_mentions) for (var n = 0; n < u.user_mentions.length; n++) {
        u.user_mentions[n].screenName = u.user_mentions[n].screen_name;
      }
      if (u.hashtags) for (n = 0; n < u.hashtags.length; n++) {
        u.hashtags[n].hashtag = u.hashtags[n].text;
      }
      if (u.symbols) for (n = 0; n < u.symbols.length; n++) {
        u.symbols[n].cashtag = u.symbols[n].text;
      }
      var r = [];

      for (var a in u) {
        r = r.concat(u[a]);
      }

      return od(e, r), dd(e, r, t);
    },
    configs: cd,
    convertUnicodeIndices: function convertUnicodeIndices(e, u, t) {
      if (0 != u.length) {
        var n = 0,
            r = 0;
        u.sort(function (e, u) {
          return e.indices[0] - u.indices[0];
        });

        for (var a = 0, d = u[0]; n < e.length;) {
          if (d.indices[0] == (t ? n : r)) {
            var i = d.indices[1] - d.indices[0];
            if (d.indices[0] = t ? r : n, d.indices[1] = d.indices[0] + i, ++a == u.length) break;
            d = u[a];
          }

          var o = e.charCodeAt(n);
          o >= 55296 && o <= 56319 && n < e.length - 1 && (o = e.charCodeAt(n + 1)) >= 56320 && o <= 57343 && n++, r++, n++;
        }
      }
    },
    extractCashtags: function extractCashtags(e) {
      for (var u = [], t = nr(e), n = 0; n < t.length; n++) {
        u.push(t[n].cashtag);
      }

      return u;
    },
    extractCashtagsWithIndices: nr,
    extractEntitiesWithIndices: Oa,
    extractHashtags: ld,
    extractHashtagsWithIndices: ka,
    extractHtmlAttrsFromOptions: Da,
    extractMentions: fd,
    extractMentionsOrListsWithIndices: Ea,
    extractMentionsWithIndices: sd,
    extractReplies: function extractReplies(e) {
      if (!e) return null;
      var u = e.match(pd);
      return !u || RegExp.rightContext.match(Sa) ? null : u[1];
    },
    extractUrls: function extractUrls(e, u) {
      for (var t = [], n = na(e, u), r = 0; r < n.length; r++) {
        t.push(n[r].url);
      }

      return t;
    },
    extractUrlsWithIndices: na,
    getTweetLength: no,
    getUnicodeTextLength: ro,
    hasInvalidCharacters: $i,
    hitHighlight: function hitHighlight(e, u, t) {
      if (t = t || {}, 0 === (u = u || []).length) return e;
      var n,
          r,
          a,
          d,
          i,
          o,
          c,
          l = t.tag || "em",
          s = ["<".concat(l, ">"), "</".concat(l, ">")],
          f = ao(e),
          p = "",
          h = 0,
          v = f[0],
          g = 0,
          _ = 0,
          b = !1,
          m = v,
          y = [];

      for (n = 0; n < u.length; n += 1) {
        for (r = 0; r < u[n].length; r += 1) {
          y.push(u[n][r]);
        }
      }

      for (a = 0; a < y.length; a += 1) {
        for (d = y[a], i = s[a % 2], o = !1; null != v && d >= g + v.length;) {
          p += m.slice(_), b && d === g + m.length && (p += i, o = !0), f[h + 1] && (p += "<".concat(f[h + 1], ">")), g += m.length, _ = 0, m = v = f[h += 2], b = !1;
        }

        o || null == v ? o || (o = !0, p += i) : (c = d - g, p += m.slice(_, c) + i, _ = c, b = a % 2 == 0);
      }

      if (null != v) for (_ < m.length && (p += m.slice(_)), a = h + 1; a < f.length; a += 1) {
        p += a % 2 == 0 ? f[a] : "<".concat(f[a], ">");
      }
      return p;
    },
    htmlEscape: La,
    isInvalidTweet: fl,
    isValidHashtag: function isValidHashtag(e) {
      if (!e) return !1;
      var u = ld(e);
      return 1 === u.length && u[0] === e.slice(1);
    },
    isValidList: function isValidList(e) {
      var u = e.match(pl);
      return !(!u || "" != u[1] || !u[4]);
    },
    isValidTweetText: function isValidTweetText(e, u) {
      return !fl(e, u);
    },
    isValidUrl: function isValidUrl(e, u, t) {
      if (null == u && (u = !0), null == t && (t = !0), !e) return !1;
      var n = e.match(Fl);
      if (!n || n[0] !== e) return !1;
      var r = n[1],
          a = n[2],
          d = n[3],
          i = n[4],
          o = n[5];
      return !!((!t || Bl(r, Dl) && r.match(/^https?$/i)) && Bl(d, jl) && Bl(i, Tl, !0) && Bl(o, Al, !0)) && (u && Bl(a, Rl) || !u && Bl(a, El));
    },
    isValidUsername: function isValidUsername(e) {
      if (!e) return !1;
      var u = fd(e);
      return 1 === u.length && u[0] === e.slice(1);
    },
    linkTextWithEntity: td,
    linkToCashtag: Xa,
    linkToHashtag: ud,
    linkToMentionAndList: ad,
    linkToText: Ka,
    linkToTextWithSymbol: Ya,
    linkToUrl: rd,
    modifyIndicesFromUTF16ToUnicode: function modifyIndicesFromUTF16ToUnicode(e, u) {
      id(e, u, !0);
    },
    modifyIndicesFromUnicodeToUTF16: od,
    regexen: Hl,
    removeOverlappingEntities: sa,
    parseTweet: eo,
    splitTags: ao,
    standardizeIndices: function standardizeIndices(e, u, t) {
      var n = ro(e);

      if (e.length - n > 0) {
        var r = Array.from(e),
            a = 0 === u ? "" : r.slice(0, u).join(""),
            d = r.slice(u, t).join("");
        return [a.length, a.length + d.length];
      }

      return [u, t];
    },
    tagAttrs: Ja
  };

  var ls = function ls(e) {
    return s(p, null, s("div", {
      className: "tweet-text",
      dangerouslySetInnerHTML: {
        __html: X(function () {
          var u = cs.autoLink(e.text, {
            urlEntities: e.entities.urls,
            targetBlank: !0
          });
          return e.entities.urls.forEach(function (e) {
            var t = "title=\"".concat(e.expanded_url, "\""),
                n = "title=\"".concat(e.expanded_url, "\" class=\"tweet-url\"");
            u = u.replace(t, n);
          }), u;
        }, [e])
      }
    }, e.text), s("style", {
      jsx: !0
    }, '\n        .tweet-text {\n          line-height: 24px;\n          font-size: 20px;\n          cursor: text;\n          font-family: "Segoe UI", Meiryo, system-ui, -apple-system,\n            BlinkMacSystemFont, sans-serif;\n          position: relative;\n          font-weight: 400;\n          color: rgb(15, 20, 25);\n          white-space: pre-wrap;\n        }\n\n        .tweet-text a.tweet-url {\n          color: rgb(27, 149, 224);\n          background-color: rgba(0, 0, 0, 0);\n          text-decoration: none;\n        }\n      '));
  },
      ss = function ss(e) {
    var u = e.createdAt,
        t = e.tweetUrl,
        n = X(function () {
      var e = u.getFullYear(),
          t = ("00" + (u.getMonth() + 1)).slice(-2),
          n = ("00" + u.getDate()).slice(-2);
      return "".concat(("00" + u.getHours()).slice(-2), ":").concat(("00" + u.getMinutes()).slice(-2), " \xB7 ").concat(e, "/").concat(t, "/").concat(n);
    }, [u]);
    return s(p, null, s("div", {
      className: "tweet-time"
    }, s(Ue, {
      className: "tweet-time__link",
      href: t
    }, n)), s("style", {
      jsx: !0
    }, '\n        .tweet-time {\n          margin-top: 2px;\n          height: 32px;\n\n          display: flex;\n          align-items: center;\n        }\n        .tweet-time__link {\n          font-weight: 400;\n          font-size: 15px;\n          color: rgb(83, 100, 113);\n          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,\n            Helvetica, Arial, sans-serif;\n        }\n\n        .tweet a:hover.tweet-time__link {\n          text-decoration: underline;\n        }\n      '));
  },
      fs = function fs() {
    return s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "rgb(83, 100, 113)"
    }, s("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), s("path", {
      d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
    }));
  },
      ps = function ps() {
    return s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "rgb(83, 100, 113)"
    }, s("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), s("path", {
      d: "M20 17.17L18.83 16H4V4h16v13.17zM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
    }));
  },
      hs = function hs(e) {
    var u = e.favoriteCount,
        t = e.conversationCount;
    return s(p, null, s("div", {
      className: "tweet-actions"
    }, s("a", {
      className: "tweet-actions__action"
    }, s("div", {
      className: "tweet-action__icon"
    }, s(fs, null)), s("div", {
      className: "tweet-action__count"
    }, u)), s("a", {
      className: "tweet-actions__action"
    }, s("div", {
      className: "tweet-action__icon"
    }, s(ps, null)), s("div", {
      className: "tweet-action__count"
    }, t))), s("style", {
      jsx: !0
    }, '\n        .tweet-actions {\n          display: flex;\n          padding-top: 4px;\n          margin-top: 4px;\n          border-top: 1px solid rgb(207, 217, 222);\n        }\n\n        .tweet-actions__action {\n          display: flex;\n          align-items: center;\n          margin-right: 20px;\n        }\n\n        .tweet-actions__action:hover {\n          text-decoration: underline;\n        }\n\n        .tweet-action__icon {\n          width: 32px;\n          height: 32px;\n\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n\n        .tweet-action__count {\n          color: rgb(83, 100, 113);\n          font-weight: 400;\n          font-size: 15px;\n          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,\n            Helvetica, Arial, sans-serif;\n          line-height: 20px;\n\n          margin-left: 4px;\n        }\n      '));
  },
      vs = function vs(e) {
    var u = e,
        t = u.children,
        n = __objRest(u, ["children"]);

    return s("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "rgb(255, 255, 255)"
    }, n), s("path", {
      d: "M3 22v-20l18 10-18 10z"
    }));
  },
      gs = function gs(e) {
    var u = e.photos,
        t = e.video;
    return s(p, null, s("div", {
      className: "tweet-media"
    }, s("div", {
      class: "tweet-media__space"
    }), s("div", {
      class: "tweet-media__media-wrapper media-list"
    }, null == u ? void 0 : u.map(function (e) {
      return s(Ue, {
        href: e.expandedUrl,
        className: "media-item"
      }, s("div", {
        className: "media-item__frame"
      }, s("div", {
        alt: "tweet media",
        className: "media-item__image",
        style: {
          backgroundImage: "url(".concat(e.url, "?name=360x360")
        }
      })));
    }), t && s("div", {
      className: "media-item"
    }, s("div", {
      className: "media-item__frame"
    }, s("div", {
      alt: "tweet media",
      className: "media-item__video",
      style: {
        backgroundImage: "url(".concat(t.poster)
      }
    }), s("div", {
      className: "media-item__play-icon"
    }, s(vs, {
      className: "play-icon"
    })))))), s("style", {
      jsx: !0
    }, "\n        .tweet-media {\n          position: relative;\n          margin-top: 11px;\n          border: 1px solid rgb(207, 217, 222);\n          border-radius: 12px;\n          z-index: 0;\n          overflow: hidden;\n        }\n        .tweet-media__space {\n          padding-bottom: 56.25%;\n          width: 100%;\n        }\n        .tweet-media__media-wrapper {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n        }\n        .media-list {\n          display: flex;\n        }\n        .media-item {\n          flex-grow: 1;\n          position: relative;\n        }\n        .media-item:not(:last-child) {\n          margin-right: 2px;\n        }\n        .media-item__frame {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          overflow: hidden;\n\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        .media-item__image {\n          position: absolute;\n          height: 100%;\n          width: 100%;\n          background-size: cover;\n          z-index: -1;\n        }\n        .media-item__video {\n          position: absolute;\n          height: 100%;\n          width: 100%;\n          background-size: cover;\n          background-position: center center;\n          z-index: -1;\n        }\n        .media-item__play-icon {\n          width: 67px;\n          height: 67px;\n          border: 4px solid rgb(255, 255, 255);\n          border-radius: 9999px;\n          background-color: rgb(29, 161, 242);\n\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        .play-icon {\n          padding-left: 3px;\n          width: calc(50% + 4px);\n          height: calc(50% + 4px);\n        }\n      "));
  };

  !function (e, u, t, n) {
    function r() {
      var u = Reflect.construct(HTMLElement, [], r);
      return u._vdomComponent = e, u._root = n && n.shadow ? u.attachShadow({
        mode: "open"
      }) : u, u;
    }

    (r.prototype = Object.create(HTMLElement.prototype)).constructor = r, r.prototype.connectedCallback = z, r.prototype.attributeChangedCallback = I, r.prototype.disconnectedCallback = R, t = t || e.observedAttributes || Object.keys(e.propTypes || {}), r.observedAttributes = t, t.forEach(function (e) {
      Object.defineProperty(r.prototype, e, {
        get: function get() {
          return this._vdom.props[e];
        },
        set: function set(u) {
          this._vdom ? this.attributeChangedCallback(e, null, u) : (this._props || (this._props = {}), this._props[e] = u, this.connectedCallback());
          var t = typeof u;
          null != u && "string" !== t && "boolean" !== t && "number" !== t || this.setAttribute(e, u);
        }
      });
    }), customElements.define(u || e.tagName || e.displayName || e.name, r);
  }(function (e) {
    var t = e["tweet-json"],
        n = X(function () {
      return JSON.parse(t);
    }, [t]),
        r = (a = null, G = 5, X(function () {
      return {
        current: a
      };
    }, []));
    var a;
    var d = "https://twitter.com/".concat(n.user.screen_name, "/status/").concat(n.id_str);
    var i, o, c;
    return i = function i() {
      var e;

      var u = function u(e) {
        e.composedPath().find(function (e) {
          if (e instanceof HTMLAnchorElement) return !0;
        }) || window.open(d);
      };

      return null == (e = r.current) || e.addEventListener("click", u), function () {
        var e;
        null == (e = r.current) || e.removeEventListener("click", u);
      };
    }, o = [], c = Y(H++, 3), !u.__s && re(c.__H, o) && (c.__ = i, c.__H = o, $.__H.__h.push(c)), s(p, null, s("article", {
      className: "tweet",
      ref: r
    }, s(Pe, {
      user: n.user,
      tweetUrl: d
    }), s(ls, {
      text: n.text.substring(n.display_text_range[0], n.display_text_range[1]),
      entities: {
        urls: n.entities.urls
      }
    }), Array.isArray(n.photos) && 0 !== n.photos.length && s(gs, {
      photos: n.photos
    }), n.video && s(gs, {
      video: n.video
    }), s(ss, {
      createdAt: new Date(n.created_at),
      tweetUrl: d
    }), s(hs, {
      favoriteCount: n.favorite_count,
      conversationCount: n.conversation_count
    })), s("style", {
      jsx: !0
    }, "\n        .tweet {\n          min-width: 250px;\n          max-width: 550px;\n\n          border: 1px solid rgb(207, 217, 222);\n          border-radius: 12px;\n          box-sizing: border-box;\n\n          padding: 12px 16px 4px;\n          background-color: rgb(255, 255, 255);\n\n          cursor: pointer;\n\n          transition-property: background-color;\n          transition-duration: 0.2s;\n        }\n\n        .tweet:hover {\n          background-color: rgb(247, 249, 249);\n        }\n\n        .tweet a {\n          text-decoration: none;\n        }\n      "));
  }, "embedded-tweet", [], {
    shadow: !0
  });
});